var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-water-drop",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes slideUp{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:inherit}}@keyframes slideRight{0%{opacity:0;transform:translateX(30px)}to{opacity:1;transform:translateX(0)}}@keyframes zoomIn{0%{opacity:0;transform:scale(.5)}to{opacity:1;transform:scale(1)}}@keyframes slideDown{0%{opacity:0;transform:translateY(-30px)}to{opacity:1;transform:translateY(0)}}@keyframes floating{0%,to{opacity:1;transform:translateY(0)}50%{transform:translateY(-10px)}}svg#freepik_stories-water-drop:not(.animated) .animable{opacity:0}\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-58",
    className: "animable",
    style: {
      transformOrigin: "249.992px 233.236px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shrubbery--inject-58",
    className: "animable",
    style: {
      transformOrigin: "250.517px 253.072px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463 307.52c7.31 7.31 2.13 14-6.07 13.47 3.27 8.7-2.66 15.44-5.51 16.51H47.72v-.05c-14-5.91-14.28-24.63-5.7-27.66-6-1.26-7.6-14.46.57-12.58l-.16-.12.24.15a8.08 8.08 0 0 1-1.55-1.65c-1.33-1.63-2.06-4.27-.34-5.9-4.32.7-9.33-3-7.21-7.59-5.28-2.56-4.14-11.85 1-14-5.48-4.45-3.18-13.87 3.35-15.92a6.43 6.43 0 0 1-1.53-3.89c-.58-9.72 7.54-14 9.67-14.29a9.91 9.91 0 0 1 3.54-10.69 10.34 10.34 0 0 1 8.26-2.31c-1.81-.37 2.81-8.49 3.48-9.17 2.86-2.86 6-3.22 9.84-3.3 1.85-4.58 5.4-8.83 10.21-10s10.64 2.05 11 7c4.6-3.88 13-.58 13.75 5.38a10.34 10.34 0 0 1 11 .74 9.22 9.22 0 0 1 13.14-12.54 6.13 6.13 0 1 1 11-5.46c-1.51-6.29 1-13.85 6.9-16.49s14.23 2.11 13.58 8.54a8.8 8.8 0 0 1 11.13 3.89 9 9 0 0 1 15.6-8.89 9.31 9.31 0 0 1 10.12-8.36 17.64 17.64 0 0 1 5.22 1.87c4.8 2.3 10.28 5.55 10.63 10.87a9.5 9.5 0 0 1 11.19 6.5 15.08 15.08 0 0 1 24.78-9.58c3.29-3.12 9.83-.63 10.21 3.89 1.26-2.65 5.34-2.69 7.58-.79s3.11 4.91 3.87 7.75a6.6 6.6 0 0 1 8.22-.93c-.37-3.88.44-8.08 3.17-10.86s7.64-3.53 10.52-.91c.67-6.22 6.28-11.85 12.52-11.49a22 22 0 0 1 7 2.05c4.9 2.07 10.71 5.62 10 10.9 5.1.35 9.11 6 7.75 10.94A3.47 3.47 0 0 1 337 192c1.4-4.84 6.85-4.47 10.12-2.08a7.7 7.7 0 0 1 15.27.74c2.14-2 5.9-1.65 8 .44a8.13 8.13 0 0 1 1.56 8.24 6.39 6.39 0 0 1 1.65 11.17 5 5 0 0 1 5.1 5.39 8.1 8.1 0 0 1 7.69-4c-.75-.07-1.48-3.28-1.5-3.87a7.35 7.35 0 0 1 1.43-4.71 5.72 5.72 0 0 1 6.09-2.06 9.56 9.56 0 0 1 .61-4.93c1.18-2.34 4-3.37 6.63-3.47a8.1 8.1 0 0 1 3.68.61 4.31 4.31 0 0 1 2.41 2.72 8.59 8.59 0 0 1 4.71-3.67 6.76 6.76 0 0 1 5.83.9c2.58 1.87 3.25 5.44 3.16 8.63a11.67 11.67 0 0 1 6 1.34 9.72 9.72 0 0 1 1.93 1.52 10.23 10.23 0 0 1 1.13 1.39 6.76 6.76 0 0 1 .28 7.37c5.92.14 7.83 8.89 3.39 12.52 3.42.92 4.53 7.72.54 11.12 2.3 0 5.9 4.85 5.8 7.46 2.27-5 10.83-4.12 11 2.39 5.85-2.5 10.92 2.85 9 8.55 6.1 1.21 7.15 8.68 5.19 13.72 8.35 1.19 9.21 13.78 4.08 19.45 4.43 3.23 4.44 18.32-4.78 18.64Z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "250.544px 253.072px"
    },
    id: "els2z7z5084r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.69 217.58a5.94 5.94 0 0 0-8.88-.57 6.57 6.57 0 0 0-1.17 1.52 6 6 0 0 0-4.83-1.53 6.54 6.54 0 0 0-5.35 5.47 7.17 7.17 0 0 1 12.45 1.61 6.61 6.61 0 0 0 0-1.17 7.32 7.32 0 0 0-.85-2.64 7.59 7.59 0 0 1 .65-.75 7 7 0 0 1 8.65-1 6.25 6.25 0 0 0-.67-.94Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "401.91px 219.681px"
    },
    id: "elbwlz2yzr6xt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.34 212.7a4.58 4.58 0 0 1 6.85-.44 5.3 5.3 0 0 1 .9 1.17 4.57 4.57 0 0 1 3.72-1.18 5 5 0 0 1 4.13 4.22 5.53 5.53 0 0 0-9.6 1.24 4.57 4.57 0 0 1 0-.9 5.5 5.5 0 0 1 .66-2 5.47 5.47 0 0 0-.51-.57 5.39 5.39 0 0 0-6.67-.77 3.88 3.88 0 0 1 .52-.77Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "338.88px 214.318px"
    },
    id: "elikwlrygr7b9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.7 303.42a4.88 4.88 0 0 1-.53 0 1.39 1.39 0 0 1 .53 0Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "444.435px 303.411px"
    },
    id: "eldulgjv9363j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463 307.52c7.31 7.31 2.13 14-6.07 13.47 3.27 8.7-2.66 15.44-5.51 16.51h-9.62c2.65-2.49 6.06-4.55 5-9.1-.89-3.69.74-7.81-1.83-9.65.9-1.1 2-2 2.93-3a3.55 3.55 0 0 0 1.28-2.45c0-2.48-.74-4.75-2.83-6-1.82-1.12-.23-3.62-1.62-3.81a5.62 5.62 0 0 0 4-1.8 4.17 4.17 0 0 0 .41-4.93c3.25 1 7 1.47 9.7-.74 2.51-2.09 3.17-6.22 1.83-9.33a9.68 9.68 0 0 0-7.49-5.59c3.18-.66 5.17-5 3.73-8.2a7.44 7.44 0 0 0-3.19-3.28c-3.17-1.78-7.47-1.52-9.86 1.35a8.78 8.78 0 0 0-3.77-8.61 7.3 7.3 0 0 0-8.71 1 7.62 7.62 0 0 0-.18-6.48 6.7 6.7 0 0 0-2.8-2.88c-.41-.23-1.28-.31-1.25-1a1.33 1.33 0 0 1 .17-.43 13.62 13.62 0 0 0 .71-1.55 6.12 6.12 0 0 0-.3-4.55c-1.86-3.54-5.21-3.28-7.26-2.33 2.56-3.83-1.53-10.32-5.56-6.92 2-2.5 3.26-3.76 5.54-4.22 1.69-.35 4-.13 5.12.94 1.82-2.67 1.23-9.24-3.31-9.87 3.32-4.26 1.27-9.13-3.18-10.77 1.87-1 4.71-1.42 5.74-3.81 1.17-2.67-.29-5.26-1.89-7.21l.32.09a1.92 1.92 0 0 1 .32.09 7.53 7.53 0 0 1 1.32.55 4.86 4.86 0 0 1 .55.29c.21.12.41.25.61.39l.23.17c.14.11.28.21.41.33s.27.24.4.36a.68.68 0 0 1 .12.12l.13.13a2.8 2.8 0 0 1 .28.31 7.92 7.92 0 0 1 .84 1.07 1.31 1.31 0 0 1 .17.28 2.32 2.32 0 0 1 .19.31 10.15 10.15 0 0 1 .55 1.27 1.13 1.13 0 0 1 0 .15.26.26 0 0 1 0 .11 2.17 2.17 0 0 1 .07.24 1.29 1.29 0 0 1 0 .19 1.42 1.42 0 0 1 0 .2 6.63 6.63 0 0 1-.85 4.62 5.07 5.07 0 0 1 3.86 1.73c.14.15.27.3.4.46 2.16 2.84 2.29 7.72-.87 10.33 3.42.92 4.53 7.72.54 11.12 2.3 0 5.9 4.85 5.8 7.46a3.49 3.49 0 0 1 .39-.74 4.94 4.94 0 0 1 .49-.64 2.47 2.47 0 0 1 .28-.28 4.67 4.67 0 0 1 1-.71q.36-.19.72-.36a6.91 6.91 0 0 1 .77-.25c3.21-.83 7.22.84 7.37 5.37a6.68 6.68 0 0 1 7.9 1.67 7 7 0 0 1 1.35 5.65 10.13 10.13 0 0 1-.3 1.24 7.46 7.46 0 0 1 3.11 1.44 2.6 2.6 0 0 1 .36.3 7.49 7.49 0 0 1 .81.89 10.34 10.34 0 0 1 1.8 6.76c0 .41-.06.82-.11 1.23s-.14.85-.23 1.26-.2.83-.33 1.23c-.07.21-.13.4-.21.6a6.92 6.92 0 0 1 2.07.53 4.44 4.44 0 0 1 .72.37 3.87 3.87 0 0 1 .68.46 6.21 6.21 0 0 1 .63.52l.29.29c3.85 4.08 3.87 12.71-.31 17.28 4.64 3.35 4.65 18.44-4.57 18.76Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "442.824px 269.89px"
    },
    id: "elgwag2u6mjcv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.16 329.07c-5.09 1.15-1.28-13.19 2.19-15.44-10.88-1.83-6.56-10.74-4.07-13.08-7.07-1.42-8.33-9.75-1.2-14.16-1.53-.5-3.75-2.81-2.2-6.94 1.82-4.84 9-5.36 11-5.54-1.56-.37-6.13-5.91-1.78-10.45a13.08 13.08 0 0 1-3.55 1.85A5.86 5.86 0 0 1 51 265c-.85-.49-4.08-3.6-.93-7-8 .21-2.31-10.85 4-10.48-2.9-1.82-5.21-4-4.15-7.89a9 9 0 0 1 6.54-6c-5-2.81-7.9-6.65-5.59-11.21a13.06 13.06 0 0 0-1.28.87 10.55 10.55 0 0 0-1.22 1.09A10.53 10.53 0 0 0 46 234c-2.13.26-10.25 4.57-9.67 14.29a6.43 6.43 0 0 0 1.53 3.89c-6.53 2.05-8.83 11.47-3.35 15.92-5.13 2.17-6.27 11.46-1 14-2.12 4.55 2.89 8.29 7.21 7.59-1.72 1.63-1 4.27.34 5.9a8.08 8.08 0 0 0 1.55 1.65l-.24-.15.16.12c-8.17-1.88-6.56 11.32-.57 12.58-8.58 3-8.28 21.75 5.7 27.66v.05h15c-3.87-1.22-7.33-3.99-7.5-8.43Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "46.3645px 279.96px"
    },
    id: "el9fl3up4gix",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3 337.49h.08Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "72.34px 337.49px"
    },
    id: "el7q7joe9rpl3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.11 228.52a6 6 0 0 0-8.74-1.82 6.08 6.08 0 0 0-1.33 1.35 6 6 0 0 0-4.61-2.2 6.34 6.34 0 0 0-6 4.66 7.2 7.2 0 0 1 5.08-2.16 7.54 7.54 0 0 1 7.07 5.52 5.66 5.66 0 0 0 .1-1.17 7.46 7.46 0 0 0-.52-2.74 7.53 7.53 0 0 1 .73-.65 7 7 0 0 1 8.7.24 5.53 5.53 0 0 0-.48-1.03Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "105.01px 229.703px"
    },
    id: "elk5kz00n11l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.9 212.46a4.91 4.91 0 0 1 6.59-3 5.13 5.13 0 0 1 1.25.83 5.08 5.08 0 0 1 3.3-2.54 4.89 4.89 0 0 1 5.37 2.62 5.57 5.57 0 0 0-4.3-.8 6.33 6.33 0 0 0-4.75 5.57 5 5 0 0 1-.25-.9 5.82 5.82 0 0 1 0-2.24 5.54 5.54 0 0 0-7.48 1.33 4.36 4.36 0 0 1 .27-.87Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "156.02px 211.395px"
    },
    id: "elr03sukshjz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.05 245.54a3.65 3.65 0 0 1 5.46-.28 4 4 0 0 1 .71.94 3.62 3.62 0 0 1 3-.9 4 4 0 0 1 3.25 3.39 4.41 4.41 0 0 0-7.65.9 4.43 4.43 0 0 1 0-.72 4.51 4.51 0 0 1 .54-1.61 4.31 4.31 0 0 0-5.7-1.14 4.21 4.21 0 0 1 .39-.58Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "68.065px 246.878px"
    },
    id: "elwtgz4bzf4ak",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-58",
    className: "animable",
    style: {
      transformOrigin: "106.663px 233.216px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.43 234c2.4 10.33 3.69 81.13 4.26 103.43h2.4c0-12.18-1.81-69.56-2-73.54-.57-10-.22-20.55-2.49-30.29-1.12-4.77-2.13-10.09-4-14.62-1.72-4.11-3.88-7.81-7.86-10.15a19.5 19.5 0 0 0-9.91-2.7 17.12 17.12 0 0 0-8.62 2.29 22.72 22.72 0 0 0-3 2.11c-.48.4-.93.85-1.42 1.24-.09.06-1.08.94-1 .95.62.07 1.33-.66 1.8-1a20.25 20.25 0 0 1 3.92-2.1 18.72 18.72 0 0 1 9.42-1.62 15.23 15.23 0 0 1 9.18 3.64 17 17 0 0 1 3 3.78 29.11 29.11 0 0 1 2.59 5.4 127.26 127.26 0 0 1 3.73 13.18Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "92.9377px 271.78px"
    },
    id: "elsi5b4kgswug",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.93 225.66c0-.13-.07-.25-.11-.39s-.1-.35-.16-.53a15.89 15.89 0 0 0-1-2.48 10.11 10.11 0 0 0-.52-1 14.34 14.34 0 0 0-1.14-1.71 17.13 17.13 0 0 0-1.16-1.45c-5-5.66-14.85-7.43-21.77-6.36A23.54 23.54 0 0 0 61.19 204c-5.55-1.28-10.55-.08-14.66 4.65 5.93.38 13.88 4.67 12.27 5.8s-5.95-3.07-16.15-3S31.7 217 31.44 222.57c3.46-4.31 12.32-4.67 19-4.26s10.16 2.85 7.4 3.77-12 .19-20.77 2.47S26.83 241 27.77 246a35.82 35.82 0 0 1 14.35-10c2.2-.81 6-1.55.82 2.09a79.62 79.62 0 0 0-13.14 11.79c-3.47 3.67-.05 9.39 3.82 13.91A34 34 0 0 1 44.15 250c3.07-2.24 5.75-3.15 1.91 2-3.06 4-8.78 13.1-8.34 16s8.13 12.68 8.13 12.68 15-4.82 16.64-8-3.61-22-3.17-26 4.41-.14 6.32 9.58-2 17.19-.74 18.58 9.49-1.49 11-5.89-2.52-18.26-5.66-25.19-5.62-9.5-2.25-11.48 9.53 4.59 12.38 13.87-1 16.37.52 16.9 7.26-1.32 9.75-7-3.44-17.71-8.63-23.66-6.15-7.27-2.22-6.06 9 6.24 11.37 13.82.55 12.88 2.09 13.3 6.5-5.34 5.68-10.56-6.61-13.42-11.09-17.89-1.94-4.8 3.35-.52a14.78 14.78 0 0 1 2.24 2.3c.22.27.43.56.64.85a41.66 41.66 0 0 1 2.56 4.2l.41.73c.06.12.13.23.19.34s.24.44.35.62l.17.27c.11.18.22.34.32.48s.21.25.3.35c.34.35.64.41.93.12a2 2 0 0 0 .35-.61l.18-.45a9.73 9.73 0 0 0 .29-1 12.24 12.24 0 0 0 .27-1.71 15.94 15.94 0 0 0-.46-5.31Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "63.9832px 242.101px"
    },
    id: "elvvqh88db7g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.93 225.66c0-.13-.07-.25-.11-.39s-.1-.35-.16-.53a15.89 15.89 0 0 0-1-2.48 10.11 10.11 0 0 0-.52-1 14.34 14.34 0 0 0-1.14-1.71 17.13 17.13 0 0 0-1.16-1.45c-5-5.66-14.85-7.43-21.77-6.36C54 229.35 45.85 261 45.85 280.68c0 0 15-4.82 16.64-8s-3.61-22-3.17-26 4.41-.14 6.32 9.58-2 17.19-.74 18.58 9.49-1.49 11-5.89-2.52-18.26-5.66-25.19-5.62-9.5-2.25-11.48 9.53 4.59 12.38 13.87-1 16.37.52 16.9 7.26-1.32 9.75-7-3.44-17.71-8.63-23.66-6.15-7.27-2.22-6.06 9 6.24 11.37 13.82.55 12.88 2.09 13.3 6.5-5.34 5.68-10.56-6.61-13.42-11.09-17.89-1.94-4.8 3.35-.52a14.78 14.78 0 0 1 2.24 2.3c.22.27.43.56.64.85a41.66 41.66 0 0 1 2.56 4.2l.41.73c.06.12.13.23.19.34s.24.44.35.62l.17.27c.11.18.22.34.32.48s.21.25.3.35c.34.35.64.41.93.12a2 2 0 0 0 .36-.61c.06-.15.12-.3.17-.45a7.73 7.73 0 0 0 .29-1 10.74 10.74 0 0 0 .27-1.71 15.43 15.43 0 0 0-.46-5.31Z",
    style: {
      fill: "#e6e6e6",
      transformOrigin: "73.1493px 246.062px"
    },
    id: "elt0aa8pjb1u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.08 211.74c-17.84 17.9-26.35 44.16-28.23 68.94-.76-24.34 8.9-53.28 28.23-68.94Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "59.9442px 246.21px"
    },
    id: "ele5cbz6b2vt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25,
      transformOrigin: "59.9442px 246.21px"
    },
    className: "animable",
    id: "el45w11hdl9i8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.08 211.74c-17.84 17.9-26.35 44.16-28.23 68.94-.76-24.34 8.9-53.28 28.23-68.94Z",
    id: "elr2qcc633wjs",
    className: "animable",
    style: {
      transformOrigin: "59.9442px 246.21px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M124.57 337.46h1.75c-3.11-21.65-7.93-111.84-6.54-126.42a76.49 76.49 0 0 1 2-11.94 33.87 33.87 0 0 1 3-8.15 13.49 13.49 0 0 1 2-2.85c3.84-4.1 9.53-5.15 14.83-4-1.71-1.45-7.35-1.61-10.62-.34a13.8 13.8 0 0 0-6.72 5.12 30 30 0 0 0-4.27 9.42 77.07 77.07 0 0 0-2.13 12.64 151.12 151.12 0 0 0-.15 26.14c.55 6.85 4.45 83.72 6.85 100.38Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "129.418px 260.181px"
    },
    id: "elphay4pjyhz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.89 205.77a10.39 10.39 0 0 0 .79 1 6.82 6.82 0 0 0 .55.53l.28.22a1.55 1.55 0 0 0 .45.26c.29.08.45-.07.54-.41a1.61 1.61 0 0 0 .06-.33v-.42a1.93 1.93 0 0 1 0-.24V205a30.1 30.1 0 0 1 .09-3.61c0-.26.06-.52.11-.78a10.47 10.47 0 0 1 .59-2.28c1.8-4.65 3.53-5.37 2.32-.88s-1.94 11.84-.57 15.47 6.63 5.5 7.46 4.66-2.3-3.53-3.51-9.23.15-10.74 2.21-12.94 1.92-1 .79 4.66-.53 15.51 3.12 18.22 8 1.78 8.75.9-4.25-4-5.81-11 0-13.37 2.83-13.34 2.22 2.58 2.74 8.14 3 15.86 5.57 18.1 8.92 1 9.18-.27-4.91-4.69-7.23-11.57-1.19-10.77.53-8.4 5.28 16.3 7.46 17.73 13.5-1 13.5-1 1.35-9 .57-11-7.76-5.74-11.17-7.21c-4.31-1.86-2.27-2.25.5-1.94a25 25 0 0 1 11.74 5c.82-4.28.92-9.18-2.63-10.25a58.19 58.19 0 0 0-12.63-2.67c-4.61-.45-1.94-1.35-.25-1.64a26.37 26.37 0 0 1 12.77 1.12c-1.24-3.57-7.29-12.06-13.73-10.3s-12 5.57-14.12 6-.75-2.42 3.34-5.1 9.86-5.67 13.63-4.19c-2.18-3.43-4.68-6.7-11.19-3s-7.74 7.95-9.18 7.81 2.07-5.76 5.7-8.16a10.22 10.22 0 0 0-11 2.37 17.2 17.2 0 0 0-5.4 9.61c-4.8 1.84-10.41 6.54-11.55 12a13.34 13.34 0 0 0-.22 1.34 11.31 11.31 0 0 0-.08 1.52 7.24 7.24 0 0 0 0 .81 12.06 12.06 0 0 0 .27 1.95c0 .13.06.26.08.39s.06.19.08.29a11.76 11.76 0 0 0 1.67 3.44Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "157.29px 196.547px"
    },
    id: "elxh909q09xis",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.89 205.77a8.17 8.17 0 0 0 .79 1 6.82 6.82 0 0 0 .55.53l.27.22a1.39 1.39 0 0 0 .46.26c.29.08.45-.07.54-.41a1.61 1.61 0 0 0 .06-.33v-.42a1.93 1.93 0 0 1 0-.24V205a30.1 30.1 0 0 1 .09-3.61c0-.26.06-.52.11-.78a10.47 10.47 0 0 1 .59-2.28c1.8-4.65 3.53-5.37 2.32-.88s-1.94 11.84-.57 15.47 6.63 5.5 7.46 4.66-2.3-3.53-3.51-9.23.15-10.74 2.21-12.94 1.92-1 .79 4.66-.53 15.51 3.12 18.22 8 1.78 8.75.9-4.25-4-5.81-11 0-13.37 2.83-13.34 2.22 2.58 2.74 8.14 3 15.86 5.57 18.1 8.92 1 9.18-.27-4.91-4.69-7.23-11.57-1.19-10.77.53-8.4 5.28 16.3 7.46 17.73 13.5-1 13.5-1c-7.16-12.52-23.88-29.72-43.07-33.63-4.8 1.84-10.41 6.54-11.55 12a13.34 13.34 0 0 0-.22 1.34 11.31 11.31 0 0 0-.08 1.52 7.24 7.24 0 0 0 0 .81 12.06 12.06 0 0 0 .27 1.95c0 .13.06.26.08.39s.06.19.08.29a11.41 11.41 0 0 0 1.69 3.52Z",
    style: {
      fill: "#e6e6e6",
      transformOrigin: "156.224px 203.139px"
    },
    id: "elhf11kl44blw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.66 184c17.87 4.91 32.85 18.54 43.07 33.63-8.38-15.78-25.07-30.69-43.07-33.63Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "162.195px 200.815px"
    },
    id: "elcr9jvsp5xn8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25,
      transformOrigin: "162.195px 200.815px"
    },
    className: "animable",
    id: "elrmxu40jitf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.66 184c17.87 4.91 32.85 18.54 43.07 33.63-8.38-15.78-25.07-30.69-43.07-33.63Z",
    id: "elo39gce24z8b",
    className: "animable",
    style: {
      transformOrigin: "162.195px 200.815px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M98 191.69c-1.82-2.27-9-5.11-13.46-2.86s-5.57 3.45-8 6.8-3.73 6.37-7.23 6.75c1.57-.74 4.07-3.08 6.48-8.22s7.22-9.9 12.33-9.5a13.5 13.5 0 0 1 10.15 6.4Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "83.79px 193.508px"
    },
    id: "elww0ger0ij2i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98 191.69c-1.82-2.27-9-5.11-13.46-2.86s-5.57 3.45-8 6.8-3.73 6.37-7.23 6.75c1.57-.74 4.07-3.08 6.48-8.22s7.22-9.9 12.33-9.5a13.5 13.5 0 0 1 10.15 6.4Z",
    style: {
      opacity: 0.1,
      transformOrigin: "83.79px 193.508px"
    },
    className: "animable",
    id: "elme7vg2856ir"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.67 180.56c-2.2-1.72-10.27-3.05-13.27-2.29s-12.55 5.51-15.06 10.93c4.14-8.84 7.22-12.06 13.28-13.33s13.46 2.84 14.3 3.54Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "76.505px 182.414px"
    },
    id: "elfv9z21ssw7o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.72 175.23a18.23 18.23 0 0 1-2.32-10.62c.13-3.72 1.16-8.38-4-12.73 4.68 1.67 7.44 4.06 7.47 10.25s-1.2 12.79-.32 14.47Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "84.1353px 164.24px"
    },
    id: "elk2d7dog5h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79 170c-3.67-1.4-6.3-2.32-10-1.95a39.7 39.7 0 0 1-11.08-.83c-3.68-.68-9.44 0-10.54 1.9.48-2.87 7.56-5.66 13.42-5.7s16 4.74 16 4.74Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "63.19px 166.71px"
    },
    id: "elmru2915ilq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.35 146.59A14.29 14.29 0 0 1 73.48 156c1.9 5.65 3.15 11.59 4.91 13.57 0 0-2.62-1-4.88-5.39s-2-8.8-4.5-11.79-3.39-3.98-6.66-5.8Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "70.37px 158.08px"
    },
    id: "elvo5zrwg2a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.35 146.59A14.29 14.29 0 0 1 73.48 156c1.9 5.65 3.15 11.59 4.91 13.57 0 0-2.62-1-4.88-5.39s-2-8.8-4.5-11.79-3.39-3.98-6.66-5.8Z",
    style: {
      opacity: 0.1,
      transformOrigin: "70.37px 158.08px"
    },
    className: "animable",
    id: "elcrkueeet1sl"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.14 157.32c-6.1-5.1-11.61-6.71-16-6.07s-6.42 2.25-9.59 4.83-5.44 4-6.46 3.95c1.56.56 4.57-.09 8.53-2.72a21.15 21.15 0 0 1 13.94-3 52.31 52.31 0 0 1 9.58 3.01Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "45.115px 155.666px"
    },
    id: "elw8mlsoms03i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.14 157.32c-6.1-5.1-11.61-6.71-16-6.07s-6.42 2.25-9.59 4.83-5.44 4-6.46 3.95c1.56.56 4.57-.09 8.53-2.72a21.15 21.15 0 0 1 13.94-3 52.31 52.31 0 0 1 9.58 3.01Z",
    style: {
      opacity: 0.1,
      transformOrigin: "45.115px 155.666px"
    },
    className: "animable",
    id: "elrcu8nzjnkl"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.85 154.26a42.31 42.31 0 0 1 6.15 3.36q3.09 1.89 6.09 3.92c1.94 1.3 3.85 2.63 5.78 4s4.13 2.73 6.13 4.18a73.18 73.18 0 0 1 10.49 8.92 57.85 57.85 0 0 1 7.51 9.92 56.23 56.23 0 0 1 3.29 6.24 11.25 11.25 0 0 1 1.1 4.64.27.27 0 0 1 0 .16.25.25 0 0 1-.27.07c-.85-.16-1-1.32-1.27-2-.38-1-.85-2-1.31-2.94-.83-1.74-1.76-3.44-2.75-5.1a61.27 61.27 0 0 0-7-9.41 74.49 74.49 0 0 0-9.63-8.73c-3.71-2.89-7.47-5.73-11.32-8.45-2.1-1.48-4.22-2.95-6.38-4.35-1-.67-2.08-1.33-3.13-2-1.2-.73-2.42-1.43-3.56-2.25-.08-.01-.01-.22.08-.18Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "79.0686px 176.97px"
    },
    id: "elqsw3j1wtzp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.4 149.36c-6 7.11-9.44 15.76-11.42 24.77a107.53 107.53 0 0 0-2.06 14.52c-.39 4.88-.62 9.79-.59 14.69a62.17 62.17 0 0 0 2 16.24c.21.73 1.51.38 1.29-.4-2.56-9.22-2.13-19.08-1.49-28.53s2.06-18.9 5.42-27.8a62 62 0 0 1 6.9-13.43s-.01-.1-.05-.06Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "108.389px 184.665px"
    },
    id: "elb9tt8tkbvdk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.2 166.79c-5.3-.55-8.94-7.23-8.4-11 1.94 3.41 5.74 5.66 4.27 3.87-3.1-3.77-4.69-6.22-5.09-11.47a8.8 8.8 0 0 1 3.71-7.84 31.46 31.46 0 0 0 1.46 10.56c.56 1.62 2.48 5.78 1 .42-2.36-8.44-.21-12.44-.21-12.44s2.07-3.64 5.29-4.79c-3.49 5.73-2.26 13.13-1.78 15.87s2.55 4.77 1.64.29-.1-13.34 3.62-17a14.49 14.49 0 0 1 9.78-3.66 40.08 40.08 0 0 0-3.91 5.17 16.34 16.34 0 0 0-1.84 4.06c-.29 1.1-.33 3.93 1.66 2.6a3.14 3.14 0 0 0 1-1.25c1-1.95 1.28-4.15 2.14-6.14 1.43-3.33 4.52-4.55 7.93-4.93a26.83 26.83 0 0 1 5.45 0 12.2 12.2 0 0 1 2.53.33s2 9.89 1.09 12.86-11.8 5-13 6.73 7.88 3.15 14.37-.45c0 0 2.06 4.66-1.52 6.63s-12 2.35-16.13 1.15-2.44 2.07.76 3.13 9.87 1.82 13.69.19c0 0-1 6.33-3.62 8.62s-12-.78-14.71-2.89-3.7.72-1 2.82 10 4.76 13.22 4.35c-4.62 4.41-11.46 6.6-17.82 3.14-6.78-3.67-5.58-8.93-5.58-8.93Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "118.228px 153.198px"
    },
    id: "elq4d10sinie8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.2 166.79c0 .19 0 .37-.07.55-.11 1.43.14 5.42 5.58 8.36 6.36 3.46 13.2 1.27 17.82-3.14-3.21.41-10.49-2.24-13.22-4.35s-1.74-4.92 1-2.82 12.13 5.17 14.71 2.89 3.62-8.62 3.62-8.62c-3.82 1.63-10.48.88-13.69-.19s-4.92-4.33-.76-3.13 12.55.83 16.13-1.15 1.52-6.63 1.52-6.63c-6.49 3.6-15.6 2.22-14.37.45s12.09-3.77 13-6.73-1.08-12.85-1.09-12.86c-11.52 5.92-28.16 25.5-30.18 37.37Z",
    style: {
      fill: "#e6e6e6",
      transformOrigin: "122.771px 153.412px"
    },
    id: "elxeeksjkr7t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.39 129.42c-6.94 4.29-12.77 10.19-18 16.43a80.55 80.55 0 0 0-9.39 13.83 34.87 34.87 0 0 0-2.75 7.11c2.28-13.57 18-31.41 30.19-37.37Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "121.345px 148.105px"
    },
    id: "ela16yzcm58b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25,
      transformOrigin: "121.345px 148.105px"
    },
    className: "animable",
    id: "elvk772nxoo6q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.39 129.42c-6.94 4.29-12.77 10.19-18 16.43a80.55 80.55 0 0 0-9.39 13.83 34.87 34.87 0 0 0-2.75 7.11c2.28-13.57 18-31.41 30.19-37.37Z",
    id: "elh5nheuxy14",
    className: "animable",
    style: {
      transformOrigin: "121.345px 148.105px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "393.31px 233.216px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.57 234c-2.4 10.33-3.69 81.13-4.26 103.43h-2.4c0-12.18 1.93-69.73 2.16-73.72.57-10 .1-20.37 2.37-30.11 1.12-4.77 2.13-10.09 4-14.62 1.72-4.11 3.88-7.81 7.86-10.15a19.5 19.5 0 0 1 9.91-2.7 17.12 17.12 0 0 1 8.62 2.29 22.72 22.72 0 0 1 3 2.11c.48.4.93.85 1.42 1.24.09.06 1.08.94.95.95-.62.07-1.33-.66-1.8-1a20.25 20.25 0 0 0-3.92-2.1 18.72 18.72 0 0 0-9.38-1.65 15.23 15.23 0 0 0-9.18 3.64 17 17 0 0 0-3 3.78 29.11 29.11 0 0 0-2.59 5.4 127.26 127.26 0 0 0-3.76 13.21Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "407.061px 271.78px"
    },
    id: "elwa02mq567ol",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.61 230.94a12.24 12.24 0 0 0 .27 1.71 9.73 9.73 0 0 0 .29 1l.18.45a2 2 0 0 0 .35.61c.29.29.59.23.93-.12a3.85 3.85 0 0 0 .29-.35 5 5 0 0 0 .33-.48l.17-.27c.11-.18.23-.4.35-.62s.13-.22.19-.34l.41-.73a41.66 41.66 0 0 1 2.56-4.2c.21-.29.42-.58.64-.85a14.78 14.78 0 0 1 2.24-2.3c5.29-4.28 7.83-4 3.35.52S401.85 237.68 401 242.9s4.12 11 5.68 10.56-.33-5.73 2.09-13.3 7.43-12.6 11.37-13.82 2.95.1-2.22 6.06-11.12 18-8.63 23.66 8.24 7.52 9.75 7-2.32-7.63.52-16.9 9-15.86 12.38-13.87.88 4.55-2.25 11.48-7.22 20.78-5.66 25.19 9.85 7.28 11.05 5.89-2.64-8.87-.74-18.58 5.89-13.55 6.32-9.58-4.78 22.86-3.17 26 16.64 8 16.64 8 7.71-9.77 8.13-12.68-5.29-12-8.34-16.08c-3.84-5.11-1.16-4.2 1.91-2a34 34 0 0 1 10.53 13.83c3.87-4.52 7.29-10.24 3.82-13.91a79.62 79.62 0 0 0-13.14-11.72c-5.16-3.64-1.38-2.9.82-2.09a35.82 35.82 0 0 1 14.35 10c.94-5.06-.47-19.2-9.28-21.47s-18-1.55-20.76-2.47.74-3.37 7.4-3.77 15.51-.05 19 4.26c-.26-5.54-1-11.09-11.21-11.13s-14.54 4.16-16.15 3 6.34-5.42 12.27-5.8c-4.11-4.73-9.11-5.93-14.66-4.65a23.54 23.54 0 0 0-12.89 7.72c-6.92-1.07-16.73.7-21.77 6.36a17.13 17.13 0 0 0-1.16 1.45 14.34 14.34 0 0 0-1.13 1.74 10.11 10.11 0 0 0-.52 1 15.89 15.89 0 0 0-1 2.48c-.06.18-.11.36-.16.53s-.07.26-.11.39a15.94 15.94 0 0 0-.47 5.26Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "436.012px 242.111px"
    },
    id: "elxmhwpfkrsne",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.61 230.94a10.74 10.74 0 0 0 .27 1.71 7.73 7.73 0 0 0 .29 1c.05.15.11.3.17.45a2 2 0 0 0 .36.61c.29.29.59.23.93-.12a3.85 3.85 0 0 0 .29-.35 5 5 0 0 0 .33-.48l.17-.27c.11-.18.23-.4.35-.62s.13-.22.19-.34l.41-.73a41.66 41.66 0 0 1 2.56-4.2c.21-.29.42-.58.64-.85a14.78 14.78 0 0 1 2.24-2.3c5.29-4.28 7.83-4 3.35.52S401.85 237.68 401 242.9s4.12 11 5.68 10.56-.33-5.73 2.09-13.3 7.43-12.6 11.37-13.82 2.95.1-2.22 6.06-11.12 18-8.63 23.66 8.24 7.52 9.75 7-2.32-7.63.52-16.9 9-15.86 12.38-13.87.88 4.55-2.25 11.48-7.22 20.78-5.66 25.19 9.85 7.28 11.05 5.89-2.64-8.87-.74-18.58 5.89-13.55 6.32-9.58-4.78 22.86-3.17 26 16.64 8 16.64 8c0-19.67-8.15-51.33-28.23-68.94-6.92-1.07-16.73.7-21.77 6.36a17.13 17.13 0 0 0-1.16 1.45 14.34 14.34 0 0 0-1.13 1.74 10.11 10.11 0 0 0-.52 1 15.89 15.89 0 0 0-1 2.48c-.06.18-.11.36-.16.53s-.07.26-.11.39a15.43 15.43 0 0 0-.44 5.24Z",
    style: {
      fill: "#e6e6e6",
      transformOrigin: "426.84px 246.072px"
    },
    id: "el0cf0k2d4jst",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.92 211.74c17.84 17.9 26.35 44.16 28.23 68.94.76-24.34-8.9-53.28-28.23-68.94Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "440.056px 246.21px"
    },
    id: "el6pbehp8czu4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25,
      transformOrigin: "440.056px 246.21px"
    },
    className: "animable",
    id: "eluedb8nhq0od"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.92 211.74c17.84 17.9 26.35 44.16 28.23 68.94.76-24.34-8.9-53.28-28.23-68.94Z",
    id: "el9ocp0388e6u",
    className: "animable",
    style: {
      transformOrigin: "440.056px 246.21px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M375.43 337.46h-1.75c3.11-21.65 7.93-111.84 6.54-126.42a76.49 76.49 0 0 0-2-11.94 33.87 33.87 0 0 0-3-8.15 13.49 13.49 0 0 0-2-2.85c-3.84-4.1-9.53-5.15-14.83-4 1.71-1.45 7.35-1.61 10.62-.34a13.8 13.8 0 0 1 6.72 5.12 30 30 0 0 1 4.27 9.42 77.07 77.07 0 0 1 2.13 12.64 151.12 151.12 0 0 1 .15 26.14c-.55 6.85-4.45 83.72-6.85 100.38Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "370.582px 260.181px"
    },
    id: "el0ud7phkr9i6o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.74 202.24c0-.1.05-.19.08-.29s.06-.26.08-.39a12.06 12.06 0 0 0 .27-1.95 7.24 7.24 0 0 0 0-.81 11.31 11.31 0 0 0-.08-1.52 13.34 13.34 0 0 0-.22-1.34c-1.14-5.44-6.75-10.14-11.55-12a17.2 17.2 0 0 0-5.4-9.61 10.22 10.22 0 0 0-11-2.37c3.63 2.4 7.14 8 5.7 8.16s-2.67-4.12-9.18-7.81-9-.42-11.19 3c3.77-1.48 9.55 1.51 13.63 4.19s5.43 5.51 3.34 5.1-7.69-4.24-14.12-6-12.49 6.73-13.73 10.3a26.37 26.37 0 0 1 12.77-1.12c1.69.29 4.36 1.19-.25 1.64a58.19 58.19 0 0 0-12.63 2.67c-3.55 1.07-3.45 6-2.63 10.25a25 25 0 0 1 11.74-5c2.77-.31 4.81.08.5 1.94-3.41 1.47-10.38 5.2-11.17 7.21s.57 11 .57 11 11.34 2.41 13.5 1 5.73-15.36 7.46-17.73 2.86 1.52.53 8.4-7.5 10.24-7.23 11.57 6.59 2.5 9.18.27 5-12.55 5.57-18.1-.13-8.1 2.74-8.14 4.4 6.4 2.83 13.34-6.58 10.07-5.81 11 5.1 1.8 8.75-.9 4.21-12.5 3.12-18.2-1.28-6.87.79-4.66 3.43 7.23 2.21 12.94-4.34 8.4-3.51 9.23 6.08-1 7.46-4.66.65-11-.57-15.47.52-3.77 2.32.88a10.47 10.47 0 0 1 .59 2.28c.05.26.08.52.11.78a30.1 30.1 0 0 1 .09 3.61v1.42a1.93 1.93 0 0 1 0 .24v.42a1.61 1.61 0 0 0 .06.33c.09.34.25.49.54.41a1.55 1.55 0 0 0 .45-.26l.28-.22a6.82 6.82 0 0 0 .55-.53 10.39 10.39 0 0 0 .79-1 11.76 11.76 0 0 0 1.67-3.5Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "342.67px 196.467px"
    },
    id: "elxes22kuyn19",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.74 202.24c0-.1.05-.19.08-.29s.06-.26.08-.39a12.06 12.06 0 0 0 .27-1.95 7.24 7.24 0 0 0 0-.81 11.31 11.31 0 0 0-.08-1.52 13.34 13.34 0 0 0-.22-1.34c-1.14-5.44-6.75-10.14-11.55-12-19.19 3.91-35.91 21.11-43.07 33.63 0 0 11.34 2.41 13.5 1s5.73-15.36 7.46-17.73 2.86 1.52.53 8.4-7.5 10.24-7.23 11.57 6.59 2.5 9.18.27 5-12.55 5.57-18.1-.13-8.1 2.74-8.14 4.4 6.4 2.83 13.34-6.58 10.07-5.81 11 5.1 1.8 8.75-.9S358 205.7 356.91 200s-1.28-6.87.79-4.66 3.43 7.23 2.21 12.94-4.34 8.4-3.51 9.23 6.08-1 7.46-4.66.65-11-.57-15.47.52-3.77 2.32.88a10.47 10.47 0 0 1 .59 2.28c.05.26.08.52.11.78a30.1 30.1 0 0 1 .09 3.61v1.42a1.93 1.93 0 0 1 0 .24v.42a1.61 1.61 0 0 0 .06.33c.09.34.25.49.54.41a1.39 1.39 0 0 0 .46-.26l.27-.22a6.82 6.82 0 0 0 .55-.53 8.17 8.17 0 0 0 .79-1 11.41 11.41 0 0 0 1.67-3.5Z",
    style: {
      fill: "#e6e6e6",
      transformOrigin: "343.716px 203.136px"
    },
    id: "el8bw3bp584k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.34 184c-17.87 4.91-32.85 18.54-43.07 33.63 8.38-15.78 25.07-30.69 43.07-33.63Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "337.805px 200.815px"
    },
    id: "el1ozcpk4a3hy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25,
      transformOrigin: "337.805px 200.815px"
    },
    className: "animable",
    id: "elsaq0hsj365"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.34 184c-17.87 4.91-32.85 18.54-43.07 33.63 8.38-15.78 25.07-30.69 43.07-33.63Z",
    id: "elfgnutkn13of",
    className: "animable",
    style: {
      transformOrigin: "337.805px 200.815px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M402 191.69c1.82-2.27 9-5.11 13.46-2.86s5.57 3.45 8.05 6.8 3.73 6.37 7.23 6.75c-1.57-.74-4.07-3.08-6.48-8.22s-7.22-9.9-12.33-9.5a13.5 13.5 0 0 0-10.15 6.4Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "416.26px 193.508px"
    },
    id: "el8o2potbyb18",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.33 180.56c2.2-1.72 10.27-3.05 13.27-2.29s12.55 5.51 15.06 10.93c-4.14-8.84-7.22-12.06-13.28-13.33s-13.46 2.84-14.3 3.54Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "423.495px 182.414px"
    },
    id: "el7n7u68l3j0c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.28 175.23a18.23 18.23 0 0 0 2.32-10.62c-.13-3.72-1.16-8.38 4-12.73-4.68 1.67-7.44 4.06-7.47 10.25s1.2 12.79.32 14.47Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "415.865px 164.24px"
    },
    id: "elmyaaxriyicm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.28 175.23a18.23 18.23 0 0 0 2.32-10.62c-.13-3.72-1.16-8.38 4-12.73-4.68 1.67-7.44 4.06-7.47 10.25s1.2 12.79.32 14.47Z",
    style: {
      opacity: 0.1,
      transformOrigin: "415.865px 164.24px"
    },
    className: "animable",
    id: "el1shcz4i6a9v"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421 170c3.67-1.4 6.3-2.32 10-1.95a39.7 39.7 0 0 0 11.08-.83c3.68-.68 9.44 0 10.54 1.9-.48-2.87-7.56-5.66-13.42-5.7s-16 4.74-16 4.74Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "436.81px 166.71px"
    },
    id: "elxgbmn80ej",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421 170c3.67-1.4 6.3-2.32 10-1.95a39.7 39.7 0 0 0 11.08-.83c3.68-.68 9.44 0 10.54 1.9-.48-2.87-7.56-5.66-13.42-5.7s-16 4.74-16 4.74Z",
    style: {
      opacity: 0.1,
      transformOrigin: "436.81px 166.71px"
    },
    className: "animable",
    id: "ellzwdu8iehk"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.65 146.59a14.29 14.29 0 0 0-11.13 9.41c-1.9 5.65-3.15 11.59-4.91 13.57 0 0 2.62-1 4.88-5.39s2-8.8 4.5-11.79 3.39-3.98 6.66-5.8Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "429.63px 158.08px"
    },
    id: "eltgtw65he32",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.86 157.32c6.1-5.1 11.61-6.71 16-6.07s6.42 2.25 9.59 4.83 5.44 4 6.46 3.95c-1.56.56-4.57-.09-8.53-2.72a21.15 21.15 0 0 0-13.94-3 52.31 52.31 0 0 0-9.58 3.01Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "454.885px 155.666px"
    },
    id: "el786beki0qzw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.15 154.26a42.31 42.31 0 0 0-6.12 3.36q-3.09 1.89-6.09 3.92c-1.94 1.3-3.85 2.63-5.78 4s-4.12 2.78-6.14 4.23a73.18 73.18 0 0 0-10.49 8.92 57.85 57.85 0 0 0-7.55 9.92 56.23 56.23 0 0 0-3.29 6.24 11.25 11.25 0 0 0-1.1 4.64.27.27 0 0 0 0 .16.25.25 0 0 0 .27.07c.85-.16 1-1.32 1.27-2 .38-1 .85-2 1.31-2.94.83-1.74 1.76-3.44 2.75-5.1a61.27 61.27 0 0 1 7-9.41 74.49 74.49 0 0 1 9.63-8.73c3.71-2.89 7.47-5.73 11.32-8.45 2.1-1.48 4.22-2.95 6.38-4.35 1-.67 2.08-1.33 3.13-2s2.42-1.43 3.56-2.25c.1-.06.03-.27-.06-.23Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "420.918px 176.995px"
    },
    id: "el1nb5vlap13k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.6 149.36c6 7.11 9.44 15.76 11.42 24.77a107.53 107.53 0 0 1 2.06 14.52c.39 4.88.62 9.79.59 14.69a62.17 62.17 0 0 1-2 16.24c-.21.73-1.51.38-1.29-.4 2.56-9.22 2.13-19.08 1.49-28.53s-2.06-18.9-5.42-27.8a62 62 0 0 0-6.9-13.43s.01-.1.05-.06Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "391.611px 184.665px"
    },
    id: "elqnmderiv92",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.8 166.79c5.3-.55 8.94-7.23 8.4-11-1.94 3.41-5.74 5.66-4.27 3.87 3.1-3.77 4.69-6.22 5.09-11.47a8.8 8.8 0 0 0-3.71-7.84 31.46 31.46 0 0 1-1.46 10.56c-.56 1.62-2.48 5.78-1 .42 2.36-8.44.21-12.44.21-12.44s-2.07-3.64-5.29-4.79c3.49 5.73 2.26 13.13 1.78 15.87s-2.55 4.77-1.64.29.1-13.34-3.62-17a14.49 14.49 0 0 0-9.78-3.66 40.08 40.08 0 0 1 3.91 5.17 16.34 16.34 0 0 1 1.84 4.06c.29 1.1.33 3.93-1.66 2.6a3.14 3.14 0 0 1-1-1.25c-1-1.95-1.28-4.15-2.14-6.14-1.43-3.33-4.52-4.55-7.93-4.93a26.83 26.83 0 0 0-5.45 0 12.2 12.2 0 0 0-2.53.33s-2 9.89-1.09 12.86 11.8 5 13 6.73-7.88 3.15-14.37-.45c0 0-2.06 4.66 1.52 6.63s12 2.35 16.13 1.15 2.44 2.07-.76 3.13-9.87 1.82-13.69.19c0 0 1 6.33 3.62 8.62s12-.78 14.71-2.89 3.7.72 1 2.82-10 4.76-13.22 4.35c4.62 4.41 11.46 6.6 17.82 3.14 6.78-3.67 5.58-8.93 5.58-8.93Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "381.772px 153.198px"
    },
    id: "el5771cdbfech",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.8 166.79c0 .19.05.37.07.55.11 1.43-.14 5.42-5.58 8.36-6.36 3.46-13.2 1.27-17.82-3.14 3.21.41 10.49-2.24 13.22-4.35s1.74-4.92-1-2.82-12.13 5.17-14.71 2.89-3.62-8.62-3.62-8.62c3.82 1.63 10.48.88 13.69-.19s4.92-4.33.76-3.13-12.55.83-16.13-1.15-1.52-6.63-1.52-6.63c6.49 3.6 15.6 2.22 14.37.45s-12.09-3.77-13-6.73 1.08-12.85 1.09-12.86c11.52 5.92 28.16 25.5 30.18 37.37Z",
    style: {
      fill: "#e6e6e6",
      transformOrigin: "377.229px 153.412px"
    },
    id: "el919u8bb3mrh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.61 129.42c6.94 4.29 12.77 10.19 18 16.43a80.55 80.55 0 0 1 9.46 13.83 34.87 34.87 0 0 1 2.75 7.11c-2.28-13.57-18-31.41-30.19-37.37Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "378.715px 148.105px"
    },
    id: "ellkiu2bd93mn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25,
      transformOrigin: "378.715px 148.105px"
    },
    className: "animable",
    id: "el8kbq2fzjrt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.61 129.42c6.94 4.29 12.77 10.19 18 16.43a80.55 80.55 0 0 1 9.46 13.83 34.87 34.87 0 0 1 2.75 7.11c-2.28-13.57-18-31.41-30.19-37.37Z",
    id: "elfb5csc2m7xk",
    className: "animable",
    style: {
      transformOrigin: "378.715px 148.105px"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Water--inject-58",
    className: "animable",
    style: {
      transformOrigin: "250px 349.075px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideUp",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--water--inject-58",
    className: "animable",
    style: {
      transformOrigin: "250px 349.075px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 349.08,
    rx: 203.15,
    ry: 117.28,
    style: {
      fill: "#b0bec5",
      transformOrigin: "250px 349.08px"
    },
    id: "elgx734119fk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 349.08,
    rx: 203.15,
    ry: 117.28,
    style: {
      fill: "#fff",
      opacity: 0.6,
      transformOrigin: "250px 349.08px"
    },
    className: "animable",
    id: "elpw3a75x3g9r"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "250.02px 350.145px"
    },
    className: "animable",
    id: "el1cvq0bd7ddn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.11 422.07c-3.74.28-7.32.11-11 .23a75.77 75.77 0 0 0-10.82 1.11 16.71 16.71 0 0 0-6.22 2c-2.28 1.61-1.73 3.63-.49 5.13 1.74 2.18 4.54 4 6.75 6q3.12-1.62 6.16-3.32c-1-1.48-1.7-3-2.62-4.05-.26-.27-.51-.56-.37-.88.24-.55 1.67-1.11 3.28-1.46a47.56 47.56 0 0 1 5.14-.7q3.58-.33 7.17-.62c1.8-1.21 3.54-2.44 5.25-3.68-.75.11-1.49.17-2.23.24Z",
    style: {
      fill: "#fff",
      opacity: 0.7,
      transformOrigin: "393.422px 429.185px"
    },
    className: "animable",
    id: "el8y3bit18eed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.38 368.21a12.88 12.88 0 0 0-5.29 6.49 15.71 15.71 0 0 0-1 7.83c.35 2.69 1.44 5.43-.76 8.19-2.62 3.28-9.43 5.58-15.45 5.89a34.66 34.66 0 0 1-15.52-2.79 18.34 18.34 0 0 1-6.57-4.2c-3.36-3.77-1.86-9.16 3.7-13.36 4.72-3.58 11.8-6.16 16.55-9.72 8.26-6.24 7.45-13.82 12.8-20.7a6 6 0 0 1 3.08-2.25c2.3-.69 4.62.13 5.47 1.22s.9 2.43 1.89 3.48c1.81 1.86 6.45 2.35 10.8 1.72a43.76 43.76 0 0 0 9.07-2.51c0-1.48-.11-2.95-.24-4.42h-.05l-6.75 1.92a14.2 14.2 0 0 1-3.08.65 8.17 8.17 0 0 1-3.27-.58 14.48 14.48 0 0 1-5.76-3.57c-2-2.28-2.48-5-2.89-7.74s-.83-5.46-2.86-7.74-5.95-4-11-3.94c-2.75.06-5.75.66-8.19.22s-3.57-1.77-3.72-3.21.58-3 1.32-4.46c1.07-2.19 2.08-4.55.6-6.33s-5-2.51-6.41-4.21c-1.77-2 .24-5.2 4.34-6.86a8 8 0 0 1 1.93-.54 12.18 12.18 0 0 1 2.42.07 20.31 20.31 0 0 0 11.64-2.84s2.23-1.41 5.35-3q-1.77-1.79-3.64-3.54l-18.5-10.15c-8-.76-16.31-1.36-22.55-2.91-16.57-4.1-13.62-13.59-29.21-18.05a60.77 60.77 0 0 1-7.18-2.11 7.16 7.16 0 0 1-3.56-3.28c-1.32-2.24-2.21-4.56-1.71-7-8.36-2.39-16.94-4.42-25.68-6.1-.72.19-1.47.38-2.26.53-4.41.87-8.66 1.09-12.57 2.4a51.85 51.85 0 0 0-9.13 4.13c-2.77 1.56-5.46 3.29-8.91 4.24a28.07 28.07 0 0 1-10.47.62c-6.05-.7-10.87-2.64-16-4.22a42.76 42.76 0 0 0-17.8-2.07c-4.33.51-8.77 1.87-12.89 1.74a14.7 14.7 0 0 1-9.83-4.12c-2.22-2-4.23-4.22-8.12-5.24a31.36 31.36 0 0 0-4.69-.72q-8.54 1.26-16.83 2.93a3.37 3.37 0 0 1 .49 1.5c0 .57-.13 1.18-1.15 1.72a32.53 32.53 0 0 1-5.38 1.62c-5.21 1.42-8 3.54-9.22 5.49s-1.29 3.87-2.65 5.83c-1.18 1.69-4.15 3.68-9.33 4.44a32.39 32.39 0 0 1-9.55-.14c-2.72-.43-4.88-1.09-7.46-1.57a68.48 68.48 0 0 0-14.23-.89 212 212 0 0 0-20.14 10.19 176.06 176.06 0 0 0-15.62 10.13 31.1 31.1 0 0 0 7 3.92c2.47 1 5.4 2 5.21 3.45-.14 1.2-2.38 2.45-4.57 3.61a19.83 19.83 0 0 1-6.58 2.39c-4.27.72-8.2 0-11.84-.46-1.32-.17-2.76-.29-4.27-.37q-2.06 2-4 4a21.91 21.91 0 0 1 3.82.41c6.32 1.32 8.44 5.34 10.23 9s4.32 7.61 10.93 8.63c5 .76 11.19-.38 16.5.05 6.54.54 8.9 3.2 9.79 5.23 1.23 2.81-1.53 6-3 8.95a7.44 7.44 0 0 0 .08 6.53c1.12 2.69 5.56 6.81.44 8.51-3.23 1.07-4.32-2.21-6.25-3.48-3.42-2.23-9.69-2.79-15.74-1.93a52.76 52.76 0 0 0-16.72 5.53 52 52 0 0 1-7.64 3.68c-7.25 2.48-16.47.69-17.27-3.34-.49-2.59 1.92-5.48 1.88-8.14 0-3.26-3.68-5.6-7.47-7.75q-1.14 3.12-2 6.26a3.55 3.55 0 0 1 .23.31c2.16 3.37-1.94 8.3 1.85 11.08 1 .76 2.62 1.44 2.1 2.51-.36.78-1.74 1.41-3.15 1.73-1.13.26-2.29.37-3.43.52v4.83a96.54 96.54 0 0 1 16.43-2.29 22.52 22.52 0 0 1 7.13.23c3.38.95 3.69 3.51 4.08 5.73 1.14 6.33 5.53 12.07 12.59 16.44a23.3 23.3 0 0 0 7 3.05c4.83 1.17 11.26 1 14.88 3 4.93 2.72 2.3 7.91-.56 12.27a7.55 7.55 0 0 1-2.69 2.72c-3 1.67-7.47 1.36-10.46.46a18.34 18.34 0 0 1-5.91-2.92c-1.68-1.3-2.83-2.87-4.76-4.06-3.69-2.23-10.29-2.87-16.53-1.59a16.13 16.13 0 0 0-5.09 1.76c-1.38.88-2.12 2-3.42 2.91a.41.41 0 0 1-.11.07q1.65 2.58 3.51 5.11a23.56 23.56 0 0 1 14.42-4.78c13.36.38 8.92 7.74 23.14 8 3.22.06 6.72-.09 9.59.23 4.24.47 6.24 1.84 10.28 2.39 4.83.66 11.11.24 16.85-.19 6.29-.48 13-1 18.19-.35 2.84.36 6 1.24 6.81 2.23 2.16 2.55 2.81 5.52 1.2 8.44a8.48 8.48 0 0 1-2.13 2.73c-3.51 2.77-10.61 3-15.17 1.88s-8-3.23-13.11-3.8a38.7 38.7 0 0 0-15.31 1.93 70 70 0 0 0-13.3 6.06 23.08 23.08 0 0 1-5.31 2.44 20 20 0 0 1-6.36.52c-.37 0-.73-.06-1.1-.09q6.84 4.91 14.73 9.48a221.59 221.59 0 0 0 30.84 14.63c8.11.82 16 1.68 19.17 4.09a3.8 3.8 0 0 1 1.59 2.93q5.94 1.74 12 3.24c.65-1.71 2.48-3.46 3-5.19.64-2.35-1.25-4.38-3.93-5.82-12.93-7-40.41-2.4-52.91-9.59a15.33 15.33 0 0 1-5.5-5.37c-1.59-2.56-2.18-5.85 1.54-8.46 2.62-1.82 6.77-2.83 10.56-3.05a56.29 56.29 0 0 1 10.75.65l14.48 1.83c4.8.59 11 .92 14.9-1.5 3.75-2.35 3.47-6.31 8.43-7.61a12.82 12.82 0 0 1 6.7.34c10.89 3.12 15.38 10.11 23.27 15.13a22.12 22.12 0 0 0 10.72 3.62c2.73.18 5.73-.12 8.51 0s5.52.87 5.91 2.36c.55 2.19-3.85 4.34-6.93 6.31-6 3.79-8.23 8.63-13.33 12.72a40.32 40.32 0 0 1-17.28 7.65q6 1.1 12 2a45.89 45.89 0 0 0 7.21-4.9c2.41-2 5.21-4.55 9.21-4.88s6.1 1.91 8.38 3.46c4.57 3.08 13.66 3.77 21.67 1.66 3.51-.94 6.85-2.35 10.47-2.79a18.24 18.24 0 0 1 9.51 1.32c2 .91 2.7 2 4.47 3a27.27 27.27 0 0 1 4.83 3.15 15.47 15.47 0 0 1 2.23 2.3q6-.49 11.86-1.19a33.23 33.23 0 0 1-12.73-5.92c-3.49-2.45-6.75-5.08-11.44-6.86-4-1.51-9.74-2.28-14.75-.49-2.33.82-4.1 2.08-6.33 3-6.87 2.86-16 1.43-19-2s-1.12-8.13 2.2-12.33a47.51 47.51 0 0 1 10.19-9.21c3.93-2.7 8.69-5.34 10.49-8.45 2.28-3.87-.53-7.4 0-11.22a3.51 3.51 0 0 1 2.26-2.9 12.63 12.63 0 0 1 3.53-.76l15-1.7c2.88-.34 5.95-.66 8.35-.08a9.77 9.77 0 0 1 4.74 3c7 6.65 17.89 11.78 31.11 14.68 3.15.69 6.57 1.31 8.46 2.81s1.39 4.21-2 5.5c-2.62 1-6.17.85-9.12 1.55-3.86.91-3.75 2-3.21 3 1.44 2.88 3.84 5.63 5.91 8.41 2.26 3 4.89 6.21 3.25 9.63a17 17 0 0 1-6.13 7.2q7.74-1.41 15.3-3.19c.79-.95 2.09-1.83 4.8-2.12a10.73 10.73 0 0 1 3.21.12q4.92-1.31 9.73-2.76c-.49-.3-1-.6-1.43-.92-6.84-4.69-10-11.1-9-17.89.23-1.5.67-3 .09-4.4-.47-1.15-1.62-2.14-1.51-3.37.14-2 3.55-3.93 6.6-5.51q5.37-2.71 10.75-5.47c6.74-3.45 14.24-7.76 13.82-12.12-.22-2.41-2.94-4.24-6.06-5.63a8.16 8.16 0 0 1-3-1.73c-.62-.74-.41-1.85.93-2.55 2.15-1.12 5-.41 7.3 0a26.88 26.88 0 0 0 12.19-1 25.12 25.12 0 0 1 3.61-1.08 8.89 8.89 0 0 1 6.11 1 17.33 17.33 0 0 1 3.12 3.11c3.66 3.81 11.18 6.11 19.77 6h2.53c5.47.53 10.65 1.65 14.08 3.8a9.38 9.38 0 0 1 2.18 1.81c2.65-2.7 5.12-5.44 7.37-8.22-1-1.9 1.06-4.1 2.2-6.19 3.33-6.23-1.65-12 2.46-18.24 1.11-1.66 3.54-3.61 8.53-4.45a26.55 26.55 0 0 1 2.81-.32q.78-2.55 1.37-5.12c-5.81-.17-12.61.97-16.99 3.76ZM342 261.12c8-.75 13.74 2.52 16.83 6.07s4.86 7.73 10.17 10.25c6.1 2.91 15.62 3.05 24.33 3.58s17.94 1.88 21 6.13c1 1.41 1 3.45-1.62 4.67a11.7 11.7 0 0 1-7.12.49c-2.08-.47-3.77-1.31-6-1.71a8.37 8.37 0 0 0-3.24 0 4.4 4.4 0 0 0-3.58 3.08c-.19 1.19.21 2.32-.36 3.52-1.3 2.8.21 5.57-3.63 7.88-2.73 1.63-6.79 2.37-10.31 2.36a47 47 0 0 1-9.73-1.3l-20.23-4.23c-4.86-1-10.23-2.42-10.54-5.44s4.28-6.15 3.32-8.9c-.7-2.07-4.34-3.12-8-3.63s-7.75-.69-10.75-1.78c-4.53-1.67-5.74-5.29-3.84-8.69s6.46-6.54 11.73-9a36.11 36.11 0 0 1 11.57-3.35ZM222 384.29c1.63 1.55 1.22 3.86-2.11 5.1s-8.11.72-11-.11c-4.14-1.19-6.48-3.61-7.27-6.27s-.06-5.57 1-8.44c1.53-4 3.85-8.33 1.3-11.64a14.05 14.05 0 0 0-5.34-3.55 55.92 55.92 0 0 0-14.84-3.92c-5.54-.74-11.66-.9-16.64-2.2-6-1.57-10.07-5-9.15-9.1s7.6-8.47 15.05-9.29c6.29-.69 12.93.9 18.42-1.5 3.76-1.65 5.54-4.76 9.85-5.68a10.74 10.74 0 0 1 7.51 1.2c2.63 1.54 4 3.72 3.88 6.08s-1.66 4.74-2.34 7.1a13.18 13.18 0 0 0 .23 7.22 9.56 9.56 0 0 0 7.47 7.21c6.73 1.64 17.64-.91 22.25 2.12 3.25 2.12 1.3 5.91-2.18 8.81s-8.29 5.37-11.55 8.32a15.64 15.64 0 0 0-4.76 7.6 1.19 1.19 0 0 0 .22.94Zm-35.71-63.61c-5-3.5-7.55-8.1-7.34-13.05a10.81 10.81 0 0 1 3.44-7.62 21.11 21.11 0 0 1 11.48-5.24 19.54 19.54 0 0 1 13.13 2.67c3 2 4.82 4.48 7.41 6.65a32.08 32.08 0 0 0 11.22 5.76 36.46 36.46 0 0 0 13.55 1.63c6.28-.46 12.45-2.69 18.74-3.63 6.61-1 13.31-.52 18.09 1.3 3.88 1.5 6.52 4.26 4.39 7.18-3.16 4.31-12.54 6.51-19.63 9.4-.38.15-1.65.42-1.65.42a82.09 82.09 0 0 1-18.39 2.48c-4.26.08-9-.08-12.69 1.66a27.64 27.64 0 0 1-3.08 1.54c-3.41 1.17-6.85-.36-7.63-2.18s-.22-4-1.82-5.54c-2.31-2.25-8.33-2.4-13.65-1.63a46 46 0 0 1-7.71.86 13.79 13.79 0 0 1-7.88-2.66Zm48.92 29.65c-3.46-.15-7.18 0-10.33-.54-4.78-.84-7.8-3.42-7.46-6.41s4-6.22 9.09-8A58.43 58.43 0 0 1 239 333l34-4c6.5-.76 13.23-1.56 19.24-3.66 2.57-.9 4.94-2 7.53-2.88 3.93-1.31 6.38-2.22 10.42-2.16 0 0 1.41.13 1.82.23 4.41 1 6.86 3.62 6.83 6.43s-3.23 6.08-8.17 7.69a44.4 44.4 0 0 1-7.89 1.53L290 337.9a100.06 100.06 0 0 0-17 3.24c-5.4 1.7-10.35 4.51-11.75 7.65-.8 1.8-.85 4-3.87 5.1s-6.07-.07-8.46-1a43.62 43.62 0 0 0-13.73-2.56Zm32-.85a3.15 3.15 0 0 1 1.17-1.2c3.54-2.5 8.94-4.07 14.13-5s10.5-1.34 15.72-2.22a80.6 80.6 0 0 0 25.81-8.9c1.27-1.25 2.19-2.72 4-3.81 3.54-2.22 9.51-2.27 13.14-1s5.75 3.38 8.66 5c3.44 2 8 3.27 12.05 4.83s7.87 3.54 9.13 6.32-.65 6.54-5.66 8.61c-3.06 1.26-6.75 1.73-9.9 2.9-8.15 3-10.87 9.86-19.68 11.8-6.85 1.5-12.72-1.19-15.05-4.37s-2.68-7-6.2-9.75a11.27 11.27 0 0 0-7-2.21c-4.78 0-9.3 2.42-13.65 4.19-4.66 1.9-10.33 3.29-15.15 2.79-5.76-.6-8.62-3.65-10.94-6.47-.44-.47-.79-.99-.62-1.51Zm77.3-29.61c-5.94.36-12.43 3.5-17.59 2.55-5.49-1-4.69-6-9.93-7.22-3.35-.82-8 .22-11.69 1.67s-6.87 3.31-10.68 4.6-10.37 2.92-13.26 2.4c-1.58-.3-1.42-1.32-1.25-1.68 1.47-3.29 10.62-5.63 10.93-8.86.12-1.26-1-2.31-2.13-3.24-3.91-3.1-9.12-5.69-11.53-9.33s-1.18-8.88 5.53-11.88c6.47-2.91 15.14-2.43 20.54-.34S312 294 316 296.85c8 5.54 20 9.17 33.73 10.23 3.71.29 7.56.39 11.1.9a28.26 28.26 0 0 1 8.43 2.41c2.87 1.4 4.89 3.43 4.56 5.8s-3.52 5.08-7.84 6c-7.93 1.81-13.53-2.82-21.51-2.32Zm-123-66.57c5-4.49 15.78-7.21 23.49-6 7.89 1.29 11.56 5.91 19 7.63a36.26 36.26 0 0 0 16.73-.61c6.17-1.66 11.22-4.62 16.49-7.21s11.66-5 17.91-5.09a27.73 27.73 0 0 1 7.12 1c5.34 1.4 9.71 3.82 11.08 7.1s-.57 7.46-5.73 10.35c-1.78 1-3.83 1.81-5.72 2.74-6.36 3.1-10.6 7.51-11.26 11.67s2.32 7.95 7.85 10c3.4 1.3 8.24 1.39 11.75 2.6 3.72 1.26 1.72 3.58 1.17 5.66a2.07 2.07 0 0 1-.93 1.38c-1.3.81-3.44.61-4.85.2-10.7-3.14-13.27-12.06-25.95-13.12-4.32-.36-9.27.29-13.26-.44-4.74-.88-7.07-3.49-9.62-5.77a15.53 15.53 0 0 0-11.78-4.16c-6.5.36-12.16 4.11-18.67 5.36a27.81 27.81 0 0 1-18.07-2.86c-5.59-2.94-9.7-6.84-10.47-11.46-.47-2.89.46-6.12 3.67-8.97Zm-.06 23.81 10 5.65a11 11 0 0 0 4.87 1.71c5.09.39 9.86-3 14.84-4.83a27 27 0 0 1 12.79-1.42 23.79 23.79 0 0 1 8.77 3.13c2.77 1.73 3.82 5.67 1.66 8.24s-5.67 5.1-6 7.7c-.18 1.37.51 2.8-1 4.08-2.35 1.93-7.13 1.64-11 2.29-4.05.69-7.51 2.64-11.46 3.61a24.06 24.06 0 0 1-15.2-1.27c-3.76-1.77-5.9-4.37-8-6.9s-4.27-5.13-8.07-6.88c-3.21-1.47-7.48-2.3-10.05-4.12-3.94-2.82-2.39-7.89 3.4-11.11a16.48 16.48 0 0 1 6.85-2.08 13.19 13.19 0 0 1 7.55 2.2Zm-103.94-15.72a49.43 49.43 0 0 1 23.35.24c6.36 1.6 12.81 4.2 20.55 2.59 7.22-1.48 11.71-5.89 14.82-9.79s6.62-8.3 13.47-10.51a27.75 27.75 0 0 1 13.54-.75c3.67.79 6.5 2.09 8.08 3.59 1.33 1.27 1.77 2.69 1.05 4.05-.8 1.52-2.31 3-3.35 4.47-1.85 2.59-2.32 5.3-1.4 7.68 1 2.56 3.59 5.09 1.3 7.84s-8.86 4.42-11.59 7.21-.54 6.05-2.82 9.06-9.61 5.12-14.31 4.05-5.76-4.31-9.65-5.94c-3.34-1.4-8.71-1.4-13.26 0-1.5.46-2.88 1-4.42 1.39-5.52 1.26-9.9-1-13.35-2.87a26.59 26.59 0 0 0-13.78-3.7c-2.25 0-4.6.37-6.8.28a20.83 20.83 0 0 1-7.18-1.81c-3.56-1.44-7.08-3.15-7.9-5.69-1.36-4.23 5.57-9.36 13.65-11.39Zm-7.42 44a48.79 48.79 0 0 1-6.21-.15c-6.82-.92-8.23-5.88-5.12-10 2.89-3.76 8.77-7.13 15.55-8.88s14.22-1.84 19.68-.24a36.29 36.29 0 0 1 8.87 4.35c2.9 1.73 7.26 3.47 11.91 2.05 2.74-.83 4.94-2.63 7.79-2.8a7.22 7.22 0 0 1 3.91.92c3.37 1.72 5.49 4.16 5.95 6.91.85 5-3.52 10.52-2.93 15.53.44 3.83 3.81 7.1 8.78 9.33 1.84.84 4 1.56 5.24 2.69s1.5 2.84-.35 4.17c-2.07 1.48-5.71 1.86-8.66 1.8s-6-.39-9 .3c-3.78.88-7.69 3.91-9.65 5.44-.45 2.37-1 4.82-3 7.13a16.82 16.82 0 0 1-10.41 4.93c-6.4.6-10.05-2.68-11.68-5.78-3.17-6-3.46-12.83-.9-19.68 1.4-3.67 3.61-7.54 2.22-10.85-2.08-4.99-12.08-7.19-21.99-7.13Zm-.24 68.61c-10.89-1-16.76-6.4-21.67-11.47-3.33-3.45-6.69-7.06-6.59-11.34s4.71-9.42 12.46-11.48a28.86 28.86 0 0 1 24.44 4.53c3.5 2.38 6.74 4.41 9.28 7.2 2.93 2.16 9.18 2.65 14.57 1.14 1.09-.3 2.18-.68 3.31-.88 4.5-.73 7 1.67 9.43 3.39 3.64 2.6 9.69 4 16.37 3.91 4.2-.09 8.74-.77 12.51-.18s6.16 3.25 3.1 5.25c-3.57 2.33-9.79 1.25-14.47 2.79-2 .67-3.63 1.81-5.76 2.27-3 .64-5.54-.22-7.78-1a43.9 43.9 0 0 0-16.5-2.45c-8.4.46-16.64 3.61-24.1 6.75a20.53 20.53 0 0 1-4.24 1.43 15.64 15.64 0 0 1-4.36.14Zm132.38 45.57a15.58 15.58 0 0 1-9 7.09 29.52 29.52 0 0 1-9.27 1.3c-12.94 0-21.35-5.34-28.58-10.36l-19.1-13.26c-5.85-4.05-12.61-8.37-23-8.47-8.06-.08-17.07 2.44-24.62 1.59-8.77-1-12.56-6.32-11.19-11.57 1-3.83 4.65-8 10.88-10.53a42.17 42.17 0 0 1 7.27-2.11 23.94 23.94 0 0 1 8.61-.57 24 24 0 0 1 4.71 1.71c5.69 2.2 14.88 1.87 22.11-.81a57.74 57.74 0 0 1 7.55-2.72c5.29-1.19 10.46.28 12.66 2.6s2.11 5.32 2 8.19-.1 5.86 2.17 8.16 6.16 3.51 10.1 4.75a29.53 29.53 0 0 0 9.52 1.69c3.41-.06 7-1 10.4-.91a15.83 15.83 0 0 1 8.29 2.47c3.18 2 3.55 2.87 5.1 5.64a5.94 5.94 0 0 0 .56 1.12 12.37 12.37 0 0 1 1.26 2.51c2.05 4.5 4.34 7.55 1.57 12.53Zm40.71-32.3c-.48 1.78-.4 3.55-1.39 5.33-2.21 4.12-10.11 7.56-17.62 8.38a35.37 35.37 0 0 1-19.33-3 28.32 28.32 0 0 1-10.39-9.28c-2.32-3.22-4.15-7.12-.39-10.76s11.79-5.82 14.44-9.53c1.93-2.66 1-5.93 5.35-7.73a13.66 13.66 0 0 1 8.07-.39c2.33.6 4.11 1.62 6.26 2.35 6.91 2.31 18 1.14 25.48-2.69 2.89-1.49 5.69-3.46 9.26-3.8a7.56 7.56 0 0 1 6.41 2c1.16 1.29 2.24 3.06 3.52 4.31 1.77 1.77 6.5 4.11 8.12 6a7 7 0 0 1 1.37 4.15c-.12 1.66-1.69 3.57-3.36 5.19a13.83 13.83 0 0 1-4.69 3.19c-4.17 1.67-9.13 1.11-13.31.51s-9.26-1-13.27.78a7.7 7.7 0 0 0-4.53 5.03Zm100.38-5.74c-.48 1.6-3.06 3-5.45 4.22-3.37 1.72-7.27 3.57-11.36 3.73-4.69.19-7.91-1.92-12.58-1.82-5.37.12-10.92 3.84-9.73 6.53.67 1.63 3.17 2.62 5.1 3.79a11 11 0 0 1 4.5 4.66 5.23 5.23 0 0 1-.91 6c-1.48 1.65-4 3-6.62 4.3A49.73 49.73 0 0 1 334 417.4c-8.38 1.66-16.25 0-22.76-2a118.78 118.78 0 0 1-21.24-8.9c-3.15-1.71-6.23-3.73-6.14-6.44 0-1.34.82-2.72 1.39-4.09.87-2.12 1.19-4.25 2.58-6.35a13.11 13.11 0 0 1 8-5.13c6.23-1.36 11.37 1.34 17.65.9 4.37-.31 8.9-2.34 10.58-4.73 1.19-1.71 1-3.42 1.5-5.13a7 7 0 0 1 5.17-4.52c2-.54 4.17-.4 6.27-.73 7.3-1.12 10.74-6.87 17.9-8.62a5.69 5.69 0 0 1 1.82-.2 1.4 1.4 0 0 1 1.39 1.62c-.06 3.29-1.91 7.32 2.22 9.24l.25.43a27.81 27.81 0 0 0 11.79 4.25 65.29 65.29 0 0 1 7.45 1.17c2.23.61 3.96 1.83 3.5 3.4ZM366.59 371a7.11 7.11 0 0 1-2.78-6.24c.21-3.8 2.84-7.86 7.35-11.36 2.86-2.21 6.49-4.25 8.36-6.66 3-3.87.67-7.79-3.86-10.16s-10.91-3.49-17.12-4.59c-2.56-.45-5.48-1.21-5.25-2.81.17-1.35 2.69-2.61 5.15-3.16s5-.61 7.51-.94A32 32 0 0 0 380 320l.51-.6c-.71-2.06-1-4.3.55-6.53s5.33-4.38 9.4-4.72c4.67-.38 7.85 1.63 9.17 3.84a7.81 7.81 0 0 1 0 7.88c-1.07 2.07-2.91 4.35-1.47 6s5.82 1.9 9.66 1.61 8-.87 11.24-.16c4.37.95 5.54 3.91 5.74 6.66a5.84 5.84 0 0 1-2.27 5.55c-1.13.89-2.73 1.62-4 2.46-6 3.77-5.69 8.74-7 13.25-1.71 5.78-7.44 12-16.87 15.77s-22.66 4.18-28.07-.01Z",
    style: {
      fill: "#fff",
      opacity: 0.7,
      transformOrigin: "250.02px 350.145px"
    },
    className: "animable",
    id: "elt6y2zrvmi5"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "249.58px 348.955px"
    },
    className: "animable",
    id: "elg6ygfdxqc1n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.09 426.83a82.21 82.21 0 0 0-9.25-3.13c-2.74-.68-6.42-1-9.34.27a7.69 7.69 0 0 0-3.72 3.41 14.94 14.94 0 0 0-2 5.94c-.2 2 .11 4-.4 6a7.89 7.89 0 0 1-.48 1.33q3.47-1.6 6.84-3.3c.33-1.21.68-2.42 1.06-3.62a9.61 9.61 0 0 1 1.27-2.82 4.33 4.33 0 0 1 2.66-1.8 4 4 0 0 1 1.6.2c1.56.41 3.72.74 5.93 1.15 1.97-1.17 3.92-2.39 5.83-3.63Z",
    style: {
      fill: "#fff",
      transformOrigin: "389.495px 431.877px"
    },
    id: "elcywza2symw5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.75 312.69c7.11-1.7 15.14-4.16 17.85-8.12 2.92-4.25-1.81-7.79-4.72-11.28-2.77-3.3-3.86-7.38-1.46-11.37q-4.62 3.81-8.67 7.79a11.09 11.09 0 0 0 1.41 3.5c.88 1.42 2.08 2.6 2.87 4.09a5.71 5.71 0 0 1 .24 5.24c-1.38 2.85-5 4.47-8.1 5.12-3.56.75-7 .77-10.62 1.45-.61.12-1.23.27-1.85.44a85.85 85.85 0 0 0-5.23 9.78c4.24-3.27 11.64-5.04 18.28-6.64Z",
    style: {
      fill: "#fff",
      transformOrigin: "71.9936px 300.625px"
    },
    id: "eldzpec9262vf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.53 458.89q4.88 1 9.81 2a29 29 0 0 0-8.48-1.88c-.44-.08-.86-.1-1.33-.12Z",
    style: {
      fill: "#fff",
      transformOrigin: "183.435px 459.89px"
    },
    id: "el5e0h7prmxkf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441 389.17c-2 .45-4 .79-6 1.08-6.25.9-12-.54-17.55-1.78-5.08-1.14-10.08-2.45-15.33-3.24-2-.3-3.9-.36-5.55 1.76-1.27 1.62-1 3.56-2.82 5-2.35 1.87-7.31 2.14-10 1.11s-3.85-2.91-5.11-4.65c-5.29-7.25-14.63-13.2-26.76-17.06-2.14-.68-4.46-1.35-5.44-2.6s-.46-3 .15-4.58c1-2.74 2.07-5.48 3.1-8.23A3.68 3.68 0 0 1 351 354c1.29-.89 3.44-1.17 5.3-1.24 7-.27 13.39 1.27 20.44 0 5.67-1 10.48-3.6 15.4-5.75a101.88 101.88 0 0 1 16.8-5.6c7.64-1.82 16.17-2.82 22.48-1.2s8.88 6.63 3.68 10.4c-1.67 1.22-4 2.2-5.46 3.48-3.27 2.74-1.86 5.92.89 8.08 3.26 2.58 8 4.37 12.52 6.28a51.85 51.85 0 0 1 6.33 3.15c.48-1.43.91-2.87 1.3-4.31a35.4 35.4 0 0 1-4.68-2.19c-1.71-1-3.76-1.34-5.42-2.45-2-1.36-3.22-3.21-2.4-5.22s3.37-3.81 5.07-5.74c3.85-4.39 2.6-9.38-3-11.88-2.83-1.26-6.93-2.34-6.31-4.6s5.18-3.73 8.89-5.06a66.54 66.54 0 0 0 6.81-2.86c-.69-2.14-1.49-4.26-2.39-6.38-3.13 3.75-8.75 6.57-13 8.17-7.46 2.8-16.29 4.05-23.2 7.31-3.6 1.69-7.51 4.11-11.5 3.8-2.73-.21-4.07-1.71-4.3-3.24s.3-3.17 0-4.67c-.54-2.48-3.4-4.36-6.6-5.88-9.16-4.33-21.9-6.79-27.58-12.77-1-1.06-1.74-2.38-.61-3.67 2.36-2.72 9.58-2.56 13.85-4.63 4.42-2.14 3.83-5.54 2.75-8.17s-2.23-5.3-3.34-7.94c-.79-1.9-1.6-3.82-1.18-5.9s2.23-4.36 5.55-5.79c4.76-2 10.76-1.72 15.43-.85a36.25 36.25 0 0 1 9.79 3c13.1 6.86 4.79 21.94 17.47 29a18.76 18.76 0 0 0 10.61 2.16c3.24-.27 6.53-1.31 9.74-1.64a95.835 95.835 0 0 0-4.49-6.58 18.53 18.53 0 0 1-7-.87c-6.69-2.65-6.85-11.32-10.16-17.26-.07-.14-.16-.27-.24-.4q-5.44-4.71-11.75-9.18c-.63-.26-1.27-.52-1.92-.75-5.79-2.1-12.13-3.26-18.12-5.06-.81-.25-1.66-.55-1.95-1.29-.39-1 .33-3.29 1.33-5.48a243.81 243.81 0 0 0-45.86-18.2c-3.12.16-6.26.42-9.38.64a2.33 2.33 0 0 1-1.28-.16c-.63-.38-.46-1.35-.32-2.17.08-.4.14-.8.19-1.2-1.93-.48-3.88-.93-5.83-1.37a8.28 8.28 0 0 1-.3 2.64 9.06 9.06 0 0 1-5.68 6.12c-1.7.72-3.7 1.12-5.31 1.88a8.34 8.34 0 0 0-3.36 2.84c-2.31 3.42-1.16 7 2.92 9.06 2.16 1.06 5 1.69 7.39 2.62a15.4 15.4 0 0 1 5.32 3.24c1.64 1.64 2.22 4.11-.84 5.74a18.22 18.22 0 0 1-4.95 1.47c-8 1.57-17.42 3-22.37.31-3.64-2-3.3-5.52-5.44-8.17a16 16 0 0 0-5.55-3.84c-8-3.87-18.44-6.28-30-6.91-4-.21-8.71-.38-10.45-2.24-1-1.09-.74-2.53-.42-3.9.92-4.22 2.92-8.8 7.19-11.8 2-1.4 9-4.58 7.76-7q-6.59-.18-13.18-.13a9.87 9.87 0 0 1 2.72.92c.58.32 1 .73 1 1.23 0 1.34-3 2.34-5.06 3.31a10.44 10.44 0 0 0-4.87 4 15.42 15.42 0 0 1-1.15 2.3 4.92 4.92 0 0 1-3.15 1.73c-1.95.28-3.2-.61-4.58-1.15-5.07-2.08-14 .17-20.2-1a25.81 25.81 0 0 1-5.45-1.91c-4.19-1.78-8.89-3.21-13.39-4.76-2.89.48-5.77 1-8.63 1.57a46.5 46.5 0 0 1 13.24 4.86c4.58 2.44 9.29 5.27 16.38 5.3 4.84 0 10.12-1.3 14.84-1 7.34.44 10.61 5.49 6.08 9.47a42.17 42.17 0 0 1-6.7 4.19c-4.64 2.68-8.52 5.85-10.08 9.17s-.54 6.76 3.52 8.63c2.3 1.07 8.3 1.66 6.34 3.44-3.1 2.8-10.6.37-15.51-.25a43.06 43.06 0 0 0-11.9 0c-5.46.82-11.21 2.33-16.32 1.66-3.71-.49-8.55-1.79-9.54-5.38-.78-2.91 1.31-6.3-.09-9-1.85-3.63-9.08-5-15.73-6s-14-2.15-16.38-5.62c-1.63-2.34-.59-5.36 2-8 .32-.32.65-.64 1-.95q-5.64 2-11.11 4.14a14.3 14.3 0 0 0 .74 7.23c.82 2 2.15 4.16.85 6.5-.88 1.6-2.7 2.68-4.36 3.61-2.12 1.2-4.39 2.43-6.58 2.51-2.64.1-4.46-1.51-6.29-2.86a35.41 35.41 0 0 0-10-4.84c-.81.45-1.62.9-2.42 1.36q-7.6 4.39-14.24 9.12a27.73 27.73 0 0 1 13-2.28 19.81 19.81 0 0 1 10.38 4.33c1.55 1.15 3.07 2.39 3.3 3.95.17 1.2-.46 2.49-.51 3.73-.19 3.16 3.21 5.57 6.85 7.55 3.45 1.9 7.52 4.3 5.24 7.33a25.91 25.91 0 0 1-2.55 2.42c-2.56 2.5-2.56 5.44 0 7.28 3 2.13 8.89 2.75 10.82 5.29s-1.82 6.58-7.37 7.85-11.2 0-16.52 1.55c-5.08 1.5-8 5.06-13.14 6.36s-9.63-.15-14.3-.72a44.25 44.25 0 0 0-14 .77c-2.73.57-5.38 1.4-8.14 1.84a16.4 16.4 0 0 1-7.39-.58 12.59 12.59 0 0 1-6.54-4.43 5.23 5.23 0 0 1-.58-1.06 71.46 71.46 0 0 0-2.13 7.65c3.24 1.18 6.19 2.74 6.43 5s-2.23 4.7-3.17 7.07c-1.42 3.64.88 6.94 3.77 9.76s6.43 5.47 7.7 8.79a5.26 5.26 0 0 1-1.13 5.74c-1.73 1.89-4.88 3.37-7.72 4.89l-2 1.08c.71 1.71 1.48 3.4 2.32 5.09 1.17-.87 2.44-1.71 3.74-2.5 4.72-2.9 10.12-5.67 13.13-9.05 2.75-3.11 3.18-6.54 1.13-9.18-3.14-4.09-11.57-6.1-13.91-10.43s2.64-10.12 10.83-12.88a45.13 45.13 0 0 1 16.36-2 47 47 0 0 1 20.88 5.75c4.33 2.47 7.71 6 5.22 9.91-2.28 3.57-9.12 6.67-9.77 10.24-.57 3 3.52 5 7.67 6.43s8.92 2.68 10.52 5.28c1.34 2.19.15 4.9.8 7.27 1.93 7 18.2 8.37 23.92 14.24.75.77 1.12 1.94-.37 2.66a7.28 7.28 0 0 1-2.5.51c-3.8.3-8 1.4-10.33-.64s-2.37-4.59-4.73-6.45c-3.82-3-10.76-4.66-18.31-4.3s-15.62 2.68-21.28 6.17c-1.68 1-3.17 2.16-5 3.14-4.63 2.48-11.06 3.61-16.61 3.34A119.35 119.35 0 0 0 79 412.46c8.88 5.28 22.6 5.17 29 13 2.32 2.82 3.46 6.41 4.57 10a228.43 228.43 0 0 0 28.77 12.74c1.36-.73 2.3-1.18 2.3-1.18 3.6-1.62 5.71-4.24 5.18-6.38a2.1 2.1 0 0 1-.12-1.33 3 3 0 0 1 1-1.05 17 17 0 0 1 12.5-2.39c3.11.79 4.59 2.71 7.68 3.52 3.24.81 7.54.26 11.53-.33a47.6 47.6 0 0 1 8.13-.73c2.63.09 5.08.75 5.86 2s-.29 3-.41 4.49c-.19 2.79 3 4.94 7.18 6.05s9.18 1.35 14.12 1.57 9.95.47 14.1 1.59a17.56 17.56 0 0 1 6.55 3.16c.63.5 1.16 1.1 1.05 1.79a4 4 0 0 1-1.18 1.69c-1.17 1.23-2.34 2.45-3.51 3.69-.47.49-1 1-1.46 1.46q3.68.19 7.35.3c2.85-2.06 5.58-4.25 6.71-6.58s.27-4.93-3.14-5.92c-1.89-.54-4.34-.55-6.32-1s-3.5-1.74-2.23-3a9.39 9.39 0 0 1 4.1-1.69c12.53-2.93 26.36-2.49 37.72-7 6.5-2.6 11.21-6.49 17.74-9.08 7.65-3.05 17.47-3.87 24.34-2a23.38 23.38 0 0 1 7.66 3.6c3.28 2.3 5.67 5.21 5.09 8.52s-4.76 7-10.74 8.47c-5 1.21-10 .61-14.93.42a92 92 0 0 0-14.28.57 38.68 38.68 0 0 0-11.82 2.9c-5.73 2.7-7.66 7.09-6.45 10.51.1.26.21.52.34.78q4.38-.28 8.76-.69a4.76 4.76 0 0 1 .53-3.57c1.53-2.74 5.08-4.07 8.12-4.68 11.39-2.25 21.89.48 33.24-1.35 4-.66 8.26-1.86 11.84-1.1a11.11 11.11 0 0 1 2.11.7q7.32-2 14.42-4.4a20.79 20.79 0 0 1-5.4-1.64 12.69 12.69 0 0 1-6.92-7.73v-1.38c.15-4.72-4-8.84-11-10.85a43.57 43.57 0 0 1-5.68-1.71c-1.61-.77-2.65-2-1.88-3.35a10.52 10.52 0 0 1 2-2c2.31-2.17 3-4.7 1.81-6.69-.77-1.27-2.05-2.83 0-4a7 7 0 0 1 4.63-.51 9.05 9.05 0 0 1 3.16 1.63 18.87 18.87 0 0 0 10.28 3.31c8 .23 15.82-3.88 22.1-7.58l10-5.89c2.87-1.68 6.32-3.55 10-3.63 2.25-.06 4.05.58 6.14.83a48 48 0 0 0 8 0c11.5-.53 22.39.95 30.75 4.17A102.32 102.32 0 0 0 441 389.17ZM319 258.45c-.36-3.67 6.11-7.73 13-9.18a45.72 45.72 0 0 1 19.67.56 58 58 0 0 1 19.11 8.42c3.62 2.45 6.87 5.22 7.49 8.63a3.85 3.85 0 0 1-1 3.49 17.16 17.16 0 0 1-4.44 2.91c-4.18 2.23-8.19 4.6-11.05 7.3s-4.49 5.79-3.52 8.4c1.05 2.79 4.84 4.71 6.93 7.19s1.63 6.4-3.42 8.32a27.61 27.61 0 0 1-5 1.17 38 38 0 0 1-15.38-.66 6.71 6.71 0 0 1-4.07-3.74c-1.2-2.84-.24-6.52.63-10 .8-3.15 1.55-6.6.35-9.24-1-2.22-3.49-3.32-4.35-5.65-.58-1.57-.31-3.49-.43-5.26-.37-7.77-13.79-5.33-14.52-12.66Zm-26.75 27.95c4.64-3.42 12.23-5.41 19.2-6 9.58-.75 19.32 1.33 21.1 6.14 1.54 4.14-3.05 9.08-2.91 13.51.2 5.7 8.07 9.41 15.45 12.62l24.17 10.47c9.15 4 18.87 8.58 18.88 15.69a6.55 6.55 0 0 1-2.37 5.08c-2.79 2.55-8 4.16-12.92 5-9.08 1.49-14.63.26-22.76-.86-1.7-.23-3.7-.46-4.59-.69-.46-.12-2-.31-2-.31-5-.85-6.59-1.06-10.28-2.8-2.38-1.14-4.4-2.64-4.5-4.55s1.56-3.83 1.66-5.7-1.49-3.65-3.09-5.22c-2.24-2.17-4.66-4.37-8.65-5.54C314.4 322 309 322 303.73 322s-10.68.07-14.93-1.12-6.91-4.05-4.74-6.94c1.12-1.5 3.27-2.77 5-4.15 4.88-4 5.48-9 1.46-12.13-1.09-.85-2.5-1.58-3.1-2.58-.85-1.4-.08-3.13 1-4.72a16.67 16.67 0 0 1 3.83-3.96Zm11.17 94.6c1.09 2.29 2.11 5-.93 7.3a19.85 19.85 0 0 1-5.82 2.57 29.76 29.76 0 0 1-17 1.09c-3.39-.89-7.65-3.48-10.88-4.45-2.27-.71-5.49-1.3-7.86-1.93s-4.23-1.91-3.71-3.52c.62-2 4.2-3.5 6.93-5.08 7-4.09 9.11-10.18 4.89-14-1.32-1.18-3.18-2.15-4.27-3.43s-1.23-3 .7-4.43c3.29-2.37 9.26-1.88 14.1-2.93 6.77-1.46 10.87-5.9 17.37-7.92s13.74-1.06 19.62.21c6.31 1.38 12.45 3 16.91 5.7s7.05 6.46 5.53 10.6-7.78 8.46-15.28 9.67c-3.26.54-6.47.5-9.72.76s-6.84 1-9.13 2.49c-3.32 2.22-2.55 5.03-1.45 7.3Zm-130.66-41.23a29 29 0 0 0-10.48-6.16c-4-1.41-8.56-2.39-12.14-4.06s-6.17-4.25-4.85-7.19c1.14-2.58 5.11-4.94 9.55-6.3a49.77 49.77 0 0 1 13.89-1.89c9-.11 17.4 1.3 23.78 4 2.45 1.06 4.71 2.41 4.85 4.3.12 1.36-.88 2.82-1.57 4.23-1.39 2.92-1.13 6.22 3 7.49 2.84.88 6.79.58 10.11 1s6.1 2.31 4 4.18a22.09 22.09 0 0 1-2.8 1.69c-3.18 2-2.89 4.63-3 7a17.69 17.69 0 0 1-4.53 10.09 5.58 5.58 0 0 1-.76.91c-5.27 3.89-9.27 9-17.15 10.76-5.31 1.18-10.35-.27-13.07-2.4-3.32-2.63-4.2-6.3-2.38-9.93 1.73-3.45 5.78-6.83 6.62-10.28.61-2.77-.83-5.29-3.07-7.44Zm45.62-28.83c1.49-4.09 9.53-7.75 16.94-8.26s13.73 1.72 16.59 5c2.37 2.73 2.64 6.09 4 9.13a19.94 19.94 0 0 0 7.15 8.14 19 19 0 0 0 6.47 2.93c6 1.4 13.92.12 21.22-.72a78.65 78.65 0 0 1 15.38-.56c4.86.43 9.26 1.71 11.43 4 1.51 1.58 2.5 4.2.21 6s-6.49 2.05-9.3 1.16a6.89 6.89 0 0 0-1.73-.09 59.8 59.8 0 0 0-13.84 2.61c-5.38 1.79-9.89 4.43-15.17 6.34s-12.2 3-16.06 1.19c-5.52-2.53-.87-8.52-3.87-12.2-2.12-2.64-7.72-3.64-13.13-4.1a77.82 77.82 0 0 0-13.16-.13c-4.31.37-8.71 1.21-12.94 1.28a24.2 24.2 0 0 1-11.1-2.12c-1.91-1-3.31-2.49-2.18-4.12 1.67-2.37 7.34-3.34 10.35-5.41 4.36-3.01 1.48-6.62 2.74-10.07Zm-10.69 54.82c2.41-6.22 4.79-12.42 7.2-18.64.9-2.31 1.84-4.72 4.36-6.86 3.3-2.8 9.2-4.79 14.64-5s10.16 1.47 11.7 4.09c1 1.73.7 3.77 1 5.67a11.6 11.6 0 0 0 4.71 7.53c1.66 1.31 3.74 3 1.78 4.64s-6 1.68-9.29 2.12a25.92 25.92 0 0 0-13.95 6.44c-3.1 3-4.54 6.17-5.91 9.31-1 2.33-2.07 4.67-3.11 7a11.62 11.62 0 0 1-2.8 4.32c-2.93 2.71-8.89 4.47-14 4.48s-10-1.32-11.73-3.74a5.37 5.37 0 0 1-.41-1c-.11-2.22 1.55-3.56 3.93-5.72 1.58-1.42 3.61-2.72 5.25-4.13 3.8-3.27 5.25-6.95 6.63-10.51Zm-1.22 30.17a50.57 50.57 0 0 1 7-2.17c7.56-4 13.3-9 16.21-14.16 1.6-2.87 2.36-5.76 4.05-8.62a19.13 19.13 0 0 1 9.14-7.76 8 8 0 0 1 2.18-.64 7.58 7.58 0 0 1 2.74.3c5.14 1.27 10.69 2.84 11.78 6 .92 2.64-1.62 5.75-5.08 8.31-3.22 2.39-7.57 4.86-7.64 7.49 0 1.66 1.79 3 4 3.84 5 1.93 12 2.12 17.77 3.4s10.7 4.5 8 8.25c-3.52 4.84-16 6.33-21.51 10.8-2.13 1.73-3 3.76-5.28 5.43-3.77 2.75-10.63 3.8-15.7 3.11a23.17 23.17 0 0 1-11.51-5c-2.86-2.25-5.22-4.73-8.8-6.61-3-1.6-6.95-2.76-9.2-4.75s-2.2-5.28 1.85-7.22ZM227 275.49a5.73 5.73 0 0 1 .26-7.88c3.76-4.25 13.14-6.79 20.93-6.84s14.38 1.79 20.67 3.62c9.24 2.7 19.13 5.91 20.92 11.89a2.78 2.78 0 0 1-.18 2.39A10.27 10.27 0 0 1 287 281c-5.72 4.09-11.47 8.61-12.3 13.22-.62 3.41 1.56 6.45 4.47 9 1.35 1.23 2.91 2.65 1.75 4.26-.85 1.17-2.92 2.06-4.14 3.17-2.81 2.56-.84 6-5.08 7.93-3.65 1.68-8.52.39-9.57-1.69s.15-4.57.31-6.87c.24-3.66-2.38-7-7.11-9-3.14-1.32-7.52-2.71-6.18-5.17a12.57 12.57 0 0 1 1.6-1.82c2.76-3 1.85-6.39-2.08-8a87 87 0 0 1-13.13-5.03c-3.45-1.52-6.69-3.24-8.54-5.51Zm-89.15 31.85c-1-.57-1.85-1.26-1.68-2.15.31-1.56 3.6-2.77 5.12-4.27 2.57-2.55-.6-4.94-3.74-6.53-2.94-1.47-6-2.91-7.94-4.87-2.91-3-2.75-7.09.43-10.79s9.34-7 16.19-8.53c7.47-1.71 16.53-.94 18.19 2.8a8 8 0 0 1 .28 3.41c-.11 5.45 3.9 10.92 13.1 12.07 6.05.77 13.09-.45 19.8-1.22a136.12 136.12 0 0 1 35.86.5c5.66.89 11.63 2.9 10.54 6.41-.76 2.39-4.77 4.57-9 5.71a66.27 66.27 0 0 1-13 1.64c-2.8 1.08-8.31 3.22-9.92 5.29-1.26 1.66-.67 3.32-.55 4.93s-.58 3.62-3.28 4.76a11.66 11.66 0 0 1-7.61.19 20.17 20.17 0 0 1-4.9-2.88c-4.06-2.73-10-4.58-17-4.82-9.13-.32-19.26 2.08-28.31 1.61a28.18 28.18 0 0 1-12.57-3.26Zm-17 58.24c-2.09-1-4.57-2.68-5.7-4.81s-.14-4.82 2.58-7c3.35-2.74 9.51-5.35 8.81-8.14-.28-1.13-1.73-1.93-3.11-2.67q-5.16-2.71-10.32-5.47c-2-1.1-4.22-2.36-3.94-4.14.22-1.33 1.85-2.69 3.8-3.76 5.87-3.17 15.11-4 20.26-1.86 3.31 1.4 4.83 3.75 7.51 5.51 3.18 2.08 7.91 3.28 12.54 4.43s9.34 2.33 12.58 4.39 4.69 5.23 2.24 8.29c-1.77 2.17-5.32 4.06-6.58 6.29s-.66 4.73-4.18 6c-2.33.84-4.93.46-7.44.56-4.74.18-9.33 2.12-14 3.29s-11.9.61-15.08-.91ZM164 429.33c-4.2 2.11-9.25 1.27-14.36 2-2.17.31-4.25.09-6.42.2s-4.78.79-5.6 2a1.51 1.51 0 0 0 .05 1.78c.72 1.2 2.25 2.12 3.12 3.26s.95 2.75-.89 3.91c-2.22 1.42-5.94 1.46-8.52.89-7.75-1.7-10.23-6.75-11.18-11.53s-1.22-10-6.52-13.35c-4.6-2.92-12.21-3.89-18.68-5.58s-12.42-4.91-11.06-9.29c.7-2.22 3.19-4.4 6.11-6.3a43.64 43.64 0 0 1 16.35-6.44c6.2-1 12.8-.38 15.84 2.11 2 1.65 2.32 3.88 3.24 5.89a7.63 7.63 0 0 0 6.63 4.39c5 .53 11-2 16.21-1.82 5.51.17 8.07 3.12 9.92 5.78q3.87 5.55 7.71 11.1c1.16 1.69 2.36 3.41 2.36 5.34s-1.31 4.16-4.31 5.66Zm3.71-21.44c-1.92-7.52-8.55-14.1-18.65-18.5-5.18-2.24-11.31-4-15.14-6.93s-4.69-7.72.61-11.27c5.47-3.68 15-4.37 21.67-3s11.35 4.18 17 6.32a15 15 0 0 0 5.91 1.17c5.89-.16 10.14-5.19 16.15-6 .65-.1 2.51-.19 3.06.69.95 1.58-2 5.18-4.39 7.27s-5.74 3.85-8.38 5.86-4.53 4.57-3 6.41c2.31 2.88 11.32 2.44 13.16 5.45 1.74 2.83-4 6.39-4.65 9.65-.9 4.37 7.47 7.45 4.29 11.82-1.72 2.37-6.64 4.11-11 4.3a18.81 18.81 0 0 1-10.58-2.51 11.11 11.11 0 0 1-4.4-4.62c-.94-2-1.13-4.07-1.65-6.11Zm116.51 24.59c-6.87 5.17-18.22 8.32-28.76 9.25-8.21.73-17.27.54-24.15 3.85-1.53.72-2.86 1.6-4.49 2.22-3.11 1.19-6.79 1.32-10.11 1.24-5-.11-10.4-.75-12.15-3.15-1.28-1.78-.21-4 .31-6.16s.17-4.48-2.95-5.3-7.22.22-11 .81a44.58 44.58 0 0 1-14.36 0c-4-.72-7.71-2.47-7-5 .62-2.23 4.55-4.31 8.61-5.15a38.57 38.57 0 0 1 11.9-.31l1.09-.28c4.65-1.93 8.17-4.81 9.41-7.7.59-1.38.72-2.77 1.71-4.12a8.05 8.05 0 0 1 5.76-2.83 5.28 5.28 0 0 1 5.13 2.88c2 3.41 4 6.91 8.35 9.4s11.48 3.76 18.53 2.11c4.4-1 8.11-3 12.15-4.58a61.43 61.43 0 0 1 20.7-4 31.6 31.6 0 0 1 11.37 1.52c7.61 2.88 6.82 10.12-.04 15.3Zm84.6-33.22c-1.6 2.45-4.77 4.66-8.08 6.71a29.81 29.81 0 0 1-7.84 3.64 28.36 28.36 0 0 1-10.92.49 27.52 27.52 0 0 1-8.5-2.47c-2.13-1.05-3.93-2.42-6.9-2.79-4.92-.66-11.69 2.39-11.9 5.33-.19 2.57 3.66 4.33 3.31 6.9-.29 2.25-3.66 4.39-6.8 6.24a18.68 18.68 0 0 1-7.7 3 7.73 7.73 0 0 1-6.23-1.92c-1.13-1.23-1.46-2.71-2.13-4.09-1.3-2.62-4-4.87-7.71-6.46l-.79-.13c-3.5-2.27-10.84-1.26-16.84-1.22-1.27 0-2.71-.11-2.95-.76-.11-.32.11-.68.36-1 3.19-3.93 13.67-5.82 15.72-9.82.59-1.15.34-2.33 1.33-3.44 1.46-1.67 5.1-2.56 8.24-2.84s6.23-.17 9.34-.82c4.37-.92 8.06-3.41 8.63-5.8.8-3.45-4.13-6.27-1.63-9.69 1.54-2.08 5.5-3.63 9.34-4.39s7.71-.94 11.58-1.42a59.73 59.73 0 0 1 7.45-.76 22.7 22.7 0 0 1 11.8 3.35 76.89 76.89 0 0 1 16.13 11.68c3.65 3.57 6.72 7.88 3.7 12.48Z",
    style: {
      fill: "#fff",
      transformOrigin: "249.58px 348.955px"
    },
    id: "elvshuvffzkw",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-58",
    className: "animable",
    style: {
      transformOrigin: "248.099px 71.9145px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Cloud--inject-58",
    d: "M153.44 62.27a13.47 13.47 0 0 0-4.55-.84c-1.48-.12-1.94-.41-2.23-.73a10.85 10.85 0 0 0-13-3.85c-.86-3.53-5.13-6.59-9.83-5.56.16-4.59-5.69-9.51-11-10.63-5-1.07-9.44-.62-12.32 2.69-3.08-6-15.16-7.71-21.69-4.53-3.76 1.83-7 3.71-8.51 7.16a14.32 14.32 0 0 0-1.41 6.84c-2.55-2.24-7.65-2.85-11-1.53-3.67 1.42-4 4.18-4.13 7a12.86 12.86 0 0 0-6.67-.12c-2.32.69-3.65 2.5-3.33 4-1.83-.11-6.18 1.37-5.68 3.3.56 2.17 5.53 1.95 7.39 1.88a34.73 34.73 0 0 0 5.2-.82 8 8 0 0 0 2.71.52c3.16 0 4.5-1.38 5-2.56 1.55 3.25 7 5.73 10.94 6.73 7.32 1.87 17.68.73 22.19-4.74a8.17 8.17 0 0 0 2.18 2.66 12.67 12.67 0 0 0 6.77 2.74c3 .28 11.08.67 13.35-4.11 1.61 3.18 8.8 4.62 14.26 3.85a22.3 22.3 0 0 0 6.12-1.85 37.23 37.23 0 0 0 3.52-2.11c1.07-.64 1.56-.64 3-.2 3.75 1.13 8.1 1.59 11.93 0 3.01-1.34 3.65-3.89.79-5.19Z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "96.6645px 54.6515px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--cloud--inject-58",
    d: "M406.92 96.27a13.52 13.52 0 0 0-4.55-.84c-1.48-.12-1.94-.41-2.23-.73a10.85 10.85 0 0 0-13-3.85c-.87-3.53-5.13-6.59-9.83-5.56.16-4.58-5.7-9.51-11-10.63-5-1.07-9.44-.62-12.31 2.69-3.09-6-15.16-7.71-21.7-4.52-3.75 1.83-6.94 3.7-8.5 7.15a14.32 14.32 0 0 0-1.42 6.84c-2.54-2.24-7.64-2.85-11-1.53-3.67 1.42-3.95 4.18-4.13 7a12.9 12.9 0 0 0-6.68-.12c-2.31.69-3.64 2.5-3.32 4-1.83-.11-6.18 1.37-5.68 3.3.56 2.17 5.53 1.95 7.39 1.88a34.73 34.73 0 0 0 5.2-.82 7.9 7.9 0 0 0 2.7.52c3.17 0 4.51-1.38 5-2.56 1.55 3.25 7.05 5.73 10.93 6.73 7.33 1.87 17.69.73 22.2-4.74a8.17 8.17 0 0 0 2.18 2.66 12.67 12.67 0 0 0 6.77 2.74c3 .28 11.08.67 13.35-4.11 1.61 3.18 8.8 4.62 14.26 3.85a22.4 22.4 0 0 0 6.12-1.85 35.82 35.82 0 0 0 3.51-2.11c1.08-.64 1.57-.64 3-.2 3.75 1.13 8.1 1.59 11.93 0 3.03-1.34 3.67-3.89.81-5.19Z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "350.144px 88.653px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.25 100.39a9 9 0 0 0-2.88-.53c-.93-.07-1.23-.26-1.41-.46a6.88 6.88 0 0 0-8.26-2.4 5.29 5.29 0 0 0-6.23-3.52c.1-2.9-3.6-6-6.94-6.73-3.19-.68-6-.4-7.8 1.7-1.95-3.81-9.6-4.88-13.74-2.87-2.38 1.16-4.4 2.35-5.39 4.53a9.1 9.1 0 0 0-.89 4.34 7.63 7.63 0 0 0-7-1c-2.32.9-2.5 2.65-2.61 4.43a8.15 8.15 0 0 0-4.23-.08c-1.47.44-2.31 1.59-2.11 2.51-1.16-.06-3.92.88-3.6 2.1s3.51 1.23 4.68 1.19a22.52 22.52 0 0 0 3.3-.52 5.09 5.09 0 0 0 1.71.33c2 0 2.86-.88 3.18-1.62 1 2.06 4.46 3.63 6.93 4.26 4.63 1.19 11.2.46 14-3a5.22 5.22 0 0 0 1.38 1.68 8.07 8.07 0 0 0 4.29 1.74c1.91.18 7 .42 8.46-2.61 1 2 5.57 2.93 9 2.44a14 14 0 0 0 3.88-1.17 21.93 21.93 0 0 0 2.23-1.34 1.87 1.87 0 0 1 1.89-.13 11.34 11.34 0 0 0 7.56 0c2.01-.82 2.42-2.44.6-3.27Z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "155.273px 95.5826px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457 57.64a8.48 8.48 0 0 0-2.88-.53c-.94-.08-1.23-.26-1.41-.46a6.88 6.88 0 0 0-8.26-2.45 5.29 5.29 0 0 0-6.23-3.52c.1-2.9-3.61-6-6.94-6.73s-6-.39-7.8 1.71c-1.95-3.81-9.6-4.89-13.74-2.87-2.38 1.16-4.4 2.35-5.39 4.53a9.22 9.22 0 0 0-.9 4.34c-1.61-1.43-4.84-1.81-7-1-2.33.9-2.5 2.65-2.62 4.43a8.1 8.1 0 0 0-4.23-.07c-1.46.43-2.3 1.58-2.1 2.51-1.16-.07-3.92.87-3.6 2.09s3.5 1.24 4.68 1.19a20 20 0 0 0 3.29-.52 5.21 5.21 0 0 0 1.72.33c2 0 2.85-.87 3.17-1.62 1 2.06 4.47 3.63 6.93 4.26 4.64 1.19 11.2.47 14.06-3a5.22 5.22 0 0 0 1.37 1.74 7.93 7.93 0 0 0 4.29 1.74c1.9.18 7 .42 8.46-2.6 1 2 5.57 2.93 9 2.43a13.91 13.91 0 0 0 3.87-1.17A22.64 22.64 0 0 0 447 61a1.84 1.84 0 0 1 1.9-.13 11.34 11.34 0 0 0 7.56 0c1.93-.79 2.33-2.41.54-3.23Z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "421.011px 52.812px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lines--inject-58",
    className: "animable",
    style: {
      transformOrigin: "249.995px 334.373px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) zoomIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--lines--inject-58",
    className: "animable",
    style: {
      transformOrigin: "249.995px 334.373px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.41 372.24c-10.3-7.63-19.28-18.1-22-30.89-3.41-16.35 4.9-31.51 16.72-42.35a107.2 107.2 0 0 1 14.14-10.65c-14.84 7.86-29.32 20.52-33.36 37.6-4.82 19.59 7 38 22.21 49.34 44.74 33.37 123.55 34 170.61 5.12-47.52 24.93-124.33 23.84-168.32-8.17ZM363.35 327c-3.53-20-20.5-34.24-37.69-43-38.08-19.3-87.59-20.84-127.76-7.34 41-9.92 87.82-8 126 10.82 20.29 9.93 41.35 29.3 37.23 54-1.56 9.42-6.6 18-13 25 10.81-9.85 17.96-24.7 15.22-39.48Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.2,
      transformOrigin: "249.878px 334.524px"
    },
    className: "animable",
    id: "el1inig6enff3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.33 278.46c-52.76-27.39-129.35-26.53-180.56 4.06-13.13 8.19-25.32 19.26-31.35 33.77 6.6-14.16 18.83-24.77 32.11-32.52 51-29 126.44-29.36 178.53-2.89 19.7 10.38 39.68 27.52 41.32 51.18 1 14.5-6.12 28.42-16.05 38.62a101.76 101.76 0 0 1-20.52 16.1A96.72 96.72 0 0 0 362 371.3c9.14-8.86 16.06-20.54 17.21-33.4 2.31-26.9-19.81-47.97-41.88-59.44ZM176.79 393.71c-16-6.47-31.63-15.44-42.89-28.81a53.18 53.18 0 0 1-11.69-23.15 45.53 45.53 0 0 0 3.71 12.67c13.62 29.58 51.36 45.43 81.61 51.38 32.44 6.37 66.63 5 98.27-4.65-42.5 9.76-88.19 8.35-129.01-7.44Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      transformOrigin: "250.793px 334.202px"
    },
    className: "animable",
    id: "elrsrgog0jt8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.45 297.06c-35.15-18.25-86.19-17.68-120.31 2.71-8.75 5.45-16.87 12.83-20.89 22.5 4.4-9.44 12.54-16.51 21.39-21.67 34-19.34 84.25-19.57 119-1.93 13.13 6.92 26.44 18.34 27.54 34.1.69 9.67-4.08 19-10.69 25.74a67.85 67.85 0 0 1-13.68 10.73 64.24 64.24 0 0 0 14.09-10.32c6.1-5.9 10.7-13.68 11.47-22.25 1.53-17.93-13.21-31.97-27.92-39.61Zm-107 76.8c-10.68-4.32-21.08-10.29-28.58-19.2a35.38 35.38 0 0 1-7.79-15.43 30.6 30.6 0 0 0 2.47 8.45c9.11 19.71 34.25 30.32 54.45 34.23a135.59 135.59 0 0 0 65.48-3.1c-28.36 6.51-58.8 5.57-86-4.95Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      transformOrigin: "250.78px 334.214px"
    },
    className: "animable",
    id: "elt5nvq0vs1pj"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.25 274.75c30.94 18.41 54.67 50.95 33.81 86.19-23.41 38.08-81.95 53.89-124.15 56.11-29.73 1.73-59.88-1.45-88.33-10.49 57.38 20.68 131.94 18 184.52-14.44 53.79-34.31 49.03-87.5-5.85-117.37Zm-202.33-.54c24.46-13.17 52.26-19.73 79.84-22.13 31.28-2.55 63.15.28 93.21 9.57C267.2 241.52 192 244.43 140.34 277c-53.4 34.46-48.08 87.34 6.41 117-27.63-16.47-51.63-45.57-37.52-78.92 7.96-18.37 24.36-31.67 41.69-40.87Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.3,
      transformOrigin: "249.995px 334.373px"
    },
    className: "animable",
    id: "el1cmlollymp5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.53 292.49c21.73 12.93 38.4 35.79 23.75 60.55-16.45 26.74-57.57 37.85-87.21 39.41a172.38 172.38 0 0 1-62-7.37c40.3 14.53 92.68 12.65 129.62-10.14 37.73-24.11 34.39-61.47-4.16-82.45Zm-142.14-.38c17.19-9.25 36.72-13.86 56.09-15.54a174 174 0 0 1 65.52 6.72c-39.88-14.15-92.69-12.1-129 10.75-37.51 24.21-33.77 61.35 4.51 82.19-19.41-11.57-36.27-32-26.36-55.44 5.55-12.88 17.07-22.22 29.24-28.68Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.3,
      transformOrigin: "250.017px 334.371px"
    },
    className: "animable",
    id: "elng8wc2b0egm"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "265.701px 325.73px"
    },
    className: "animable",
    id: "elvco1w7zptbj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.6 305.69c19.89-6.69 44.4-5.93 63.25 3.63 8.51 4.35 16.92 11.43 18.66 21.31 1.36 7.33-2.18 14.68-7.53 19.53a25 25 0 0 0 6.42-12.39C307.44 325.55 297 316 287 311c-18.89-9.3-42.08-10.27-62.37-5.35Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "265.701px 325.73px"
    },
    id: "elyov0lvnz07",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M295.47 305.42c-27.24-14.15-66.79-13.7-93.24 2.1-6.78 4.23-13.07 9.94-16.18 17.44 3.4-7.32 9.72-12.8 16.58-16.8 26.33-15 65.29-15.16 92.19-1.49 10.18 5.33 20.49 14.21 21.34 26.43.53 7.48-3.17 14.68-8.29 19.94a52.76 52.76 0 0 1-10.6 8.31 49.76 49.76 0 0 0 10.92-8c4.72-4.58 8.3-10.6 8.89-17.25 1.21-13.88-10.21-24.76-21.61-30.68Zm-82.9 59.51c-8.28-3.34-16.33-8-22.15-14.87a27.43 27.43 0 0 1-6-12 23.33 23.33 0 0 0 1.91 6.55c7 15.27 26.52 23.45 42.15 26.53a105.18 105.18 0 0 0 50.74-2.4c-21.98 5.07-45.57 4.35-66.65-3.81Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      transformOrigin: "250.794px 334.193px"
    },
    className: "animable",
    id: "el6aawspkh5gl"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.65 320.1c-13.36-6.94-32.75-6.72-45.72 1-3.32 2.07-6.41 4.87-7.93 8.55a19.46 19.46 0 0 1 8.13-8.24c12.91-7.34 32-7.43 45.2-.73 5 2.63 10 7 10.46 13 .26 3.67-1.55 7.2-4.06 9.78a26.08 26.08 0 0 1-5.2 4.08 24.52 24.52 0 0 0 5.36-3.92 13.78 13.78 0 0 0 4.35-8.46c.6-6.82-5-12.16-10.59-15.06ZM232 349.28a27.31 27.31 0 0 1-10.86-7.28 13.57 13.57 0 0 1-3-5.87 11.61 11.61 0 0 0 .94 3.21c3.45 7.49 13 11.51 20.67 13a51.51 51.51 0 0 0 24.88-1.18 56.19 56.19 0 0 1-32.63-1.88Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      transformOrigin: "250.712px 334.214px"
    },
    className: "animable",
    id: "elnw762g6rzz8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.35 315.83c9.57 5.7 16.92 15.77 10.46 26.68-7.24 11.79-25.36 16.68-38.42 17.37a76 76 0 0 1-27.34-3.25c17.76 6.4 40.83 5.57 57.11-4.47 16.64-10.62 15.17-27.08-1.81-36.33Zm-62.62-.16c7.57-4.08 16.17-6.11 24.71-6.85a76.9 76.9 0 0 1 28.85 3c-17.57-6.23-40.84-5.33-56.84 4.74-16.53 10.66-14.88 27 2 36.21-8.56-5.1-16-14.1-11.62-24.42 2.46-5.72 7.53-9.84 12.9-12.68Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.3,
      transformOrigin: "250.388px 334.307px"
    },
    className: "animable",
    id: "el9ybg46v9n99"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Splash--inject-58",
    className: "animable",
    style: {
      transformOrigin: "256.669px 298.976px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) zoomIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.46 295c1.73-2.87 3.84-5.56 5.37-8.55 1.35-2.63 3.18-4.18 2.79-7-.36-2.66-3.12-3.46-5.67-4.35a9.65 9.65 0 0 1-3.45-2.13 4 4 0 0 1-1.39-2.46 3.39 3.39 0 0 1 1.1-2.63 5.88 5.88 0 0 1 5.35-1.41 8.54 8.54 0 0 1 4.73 3.1c1 1.23 1.69 2.64 2.6 3.92a7 7 0 0 0 3.61 2.87 6.33 6.33 0 0 0 6.6-1.94 9.79 9.79 0 0 0 1.72-6.52 20.75 20.75 0 0 0-2.12-8.5c-1.37-2.8-3.37-5.29-4.43-8.23a18.51 18.51 0 0 1-.74-8.56 17.36 17.36 0 0 1 4.17-9.74 10.38 10.38 0 0 1 9.74-3.25c2.62.66 4.95 2.85 5.18 5.53.3 3.41-2.57 6.15-4 9.28-2.58 5.83.16 12.54 3.09 18.2 4.9 9.43 15.71 16.37 23.83 5.65 3.32-4.39 3-11.36 7-14.84s10.47-1.8 14.08 1.63 6 8.46 9.86 11.88a18.38 18.38 0 0 0 30.52-16.4c-.89-6.17-4.48-13.6.16-17.77 3-2.67 8-1.78 10.81 1.06s3.8 7 3.95 11a34.31 34.31 0 0 1-3.22 15.83c-1.74 3.7-4.18 7.17-5 11.18s.76 9 4.66 10.21c6.12 2 11.39-6.16 17.82-5.88a3.57 3.57 0 0 1 2.48 1c1.33 1.47.34 3.76-.55 5.53-2.77 5.58-5.43 15.25-1 20.59a11 11 0 0 0 10.82 3.62c-3 .72-3.35 7.68-4.12 9.91a44.91 44.91 0 0 1-5.75 11.17 73.13 73.13 0 0 0-31.49-28c-12.07-5.57-25.41-7.72-38.64-9a139.61 139.61 0 0 0-15.57-.8 90.2 90.2 0 0 0-42.42 11.33c-7.15 4-14.05 9.32-17.13 16.9-.81 2-1.45 4.28-3.24 5.5-4.55 3.1-5.33-4.17-5.23-7.14.19-5.52-1-11.48.78-16.89a23.72 23.72 0 0 1 2.34-4.9Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "253.027px 278.711px"
    },
    id: "eltknzwg4t6n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.46 295c1.73-2.87 3.84-5.56 5.37-8.55 1.35-2.63 3.18-4.18 2.79-7-.36-2.66-3.12-3.46-5.67-4.35a9.65 9.65 0 0 1-3.45-2.13 4 4 0 0 1-1.39-2.46 3.39 3.39 0 0 1 1.1-2.63 5.88 5.88 0 0 1 5.35-1.41 8.54 8.54 0 0 1 4.73 3.1c1 1.23 1.69 2.64 2.6 3.92a7 7 0 0 0 3.61 2.87 6.33 6.33 0 0 0 6.6-1.94 9.79 9.79 0 0 0 1.72-6.52 20.75 20.75 0 0 0-2.12-8.5c-1.37-2.8-3.37-5.29-4.43-8.23a18.51 18.51 0 0 1-.74-8.56 17.36 17.36 0 0 1 4.17-9.74 10.38 10.38 0 0 1 9.74-3.25c2.62.66 4.95 2.85 5.18 5.53.3 3.41-2.57 6.15-4 9.28-2.58 5.83.16 12.54 3.09 18.2 4.9 9.43 15.71 16.37 23.83 5.65 3.32-4.39 3-11.36 7-14.84s10.47-1.8 14.08 1.63 6 8.46 9.86 11.88a18.38 18.38 0 0 0 30.52-16.4c-.89-6.17-4.48-13.6.16-17.77 3-2.67 8-1.78 10.81 1.06s3.8 7 3.95 11a34.31 34.31 0 0 1-3.22 15.83c-1.74 3.7-4.18 7.17-5 11.18s.76 9 4.66 10.21c6.12 2 11.39-6.16 17.82-5.88a3.57 3.57 0 0 1 2.48 1c1.33 1.47.34 3.76-.55 5.53-2.77 5.58-5.43 15.25-1 20.59a11 11 0 0 0 10.82 3.62c-3 .72-3.35 7.68-4.12 9.91a44.91 44.91 0 0 1-5.75 11.17 73.13 73.13 0 0 0-31.49-28c-12.07-5.57-25.41-7.72-38.64-9a139.61 139.61 0 0 0-15.57-.8 90.2 90.2 0 0 0-42.42 11.33c-7.15 4-14.05 9.32-17.13 16.9-.81 2-1.45 4.28-3.24 5.5-4.55 3.1-5.33-4.17-5.23-7.14.19-5.52-1-11.48.78-16.89a23.72 23.72 0 0 1 2.34-4.9Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "253.027px 278.711px"
    },
    className: "animable",
    id: "el680v7fx0z1w"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.94 274.54a5 5 0 0 0 1.48-.8c2.05-1.62 2.41-4.58 2.23-7.19a27 27 0 0 0-1.59-7.42c-.73-2-1.72-4-1.62-6.14a7.41 7.41 0 0 1 2.17-4.7c.9-.92 2.11-1.94 1.82-3.2-.37-1.66-2.69-1.62-4.28-2.23-2.65-1-3.54-4.56-2.59-7.23a11.86 11.86 0 0 1 2.9-4.3 11 11 0 0 0-1.76 1.5 17.36 17.36 0 0 0-4.17 9.74 18.38 18.38 0 0 0 .74 8.56c1.06 2.94 3.06 5.43 4.43 8.23a20.75 20.75 0 0 1 2.12 8.5 9.79 9.79 0 0 1-1.72 6.52Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "195.399px 252.935px"
    },
    id: "elstnrm7vk13",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.2 307a10.71 10.71 0 0 1-5.88 4.29c-5.29 1.28-10.15-2.88-14.41-6.26-11.07-8.8-24.56-13.94-38.37-16.49-13.18-2.44-27.09-3.12-40.35-1-14.59 2.33-28.48 7.81-41.67 14.32-2.6 1.29-5.62 2.64-8.28 1.48-2.88-1.25-3.88-5-3.18-8s2.65-5.64 4.3-8.31 3.07-5.74 2.52-8.82a7.61 7.61 0 0 0-4.08-5.43c-1.69-.82-3.7-1-5.14-2.22a3.23 3.23 0 0 1-.81-3.69 5.14 5.14 0 0 0-1.64 1.08 3.39 3.39 0 0 0-1.1 2.63 4 4 0 0 0 1.39 2.46 9.6 9.6 0 0 0 3.46 2.13c2.54.89 5.3 1.69 5.66 4.35.39 2.83-1.44 4.38-2.79 7-1.53 3-3.64 5.68-5.37 8.55a23.72 23.72 0 0 0-2.34 4.9c-1.76 5.41-.59 11.37-.78 16.89-.1 3 .68 10.24 5.23 7.14 1.79-1.22 2.43-3.49 3.24-5.5 3.08-7.58 10-12.92 17.13-16.9a90.2 90.2 0 0 1 42.42-11.33 139.61 139.61 0 0 1 15.57.8c13.23 1.28 26.57 3.43 38.64 9a73.13 73.13 0 0 1 31.49 28 44.91 44.91 0 0 0 5.71-11.13c.77-2.23 1.16-9.19 4.12-9.91a10.6 10.6 0 0 1-4.69-.03Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "253.012px 297.47px"
    },
    id: "elq1b7d4cf0y8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.13 252.65a5.7 5.7 0 0 1 1 0c-3.41-1.61-7.52-1.82-10.52.77-4 3.48-3.72 10.45-7 14.84-4.07 5.37-8.81 6.31-13.15 4.72a5.74 5.74 0 0 0 .47.35 7.44 7.44 0 0 0 5 .73c5.66-.85 10.33-5.08 13.31-10a80.25 80.25 0 0 1 4.22-7.09c1.59-2.18 3.93-4.06 6.67-4.32Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "234.795px 262.832px"
    },
    id: "elnvjuehhpb4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.48 251.13a3.35 3.35 0 0 0-.18-3.56c-.85-1-2.31-1.12-3.55-1.56a7.67 7.67 0 0 1-4.47-4.71 11.79 11.79 0 0 1-.22-6.61 9.66 9.66 0 0 1 .35-1.15c-3.51 4.27-.27 11.2.56 17a18.88 18.88 0 0 1-9.48 18.82c-.26.14-.54.26-.81.39a8.1 8.1 0 0 0 1-.24c3.45-1 6.13-3.73 8.26-6.63s3.84-6.1 6.23-8.79a13.19 13.19 0 0 0 2.31-2.96Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "292.794px 251.645px"
    },
    id: "elcl4hloysmqp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.07 303.3c-4.39-5.34-1.73-15 1-20.59.89-1.77 1.88-4.06.55-5.53a3.58 3.58 0 0 0-2.49-1 6.54 6.54 0 0 0-.77 0c1.57 1.73.63 4.52-.41 6.64a36.9 36.9 0 0 0-3.51 9c-.61 3.17-.27 6.67 1.68 9.24a7.73 7.73 0 0 0 4.5 2.83c-.16-.17-.37-.37-.55-.59Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "322.216px 290.029px"
    },
    id: "elc8nen3gpd66",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.81 232.76a1.82 1.82 0 0 0-.7 1.67c.29 1.15 2 1.18 2.8 2s.71 2.5 1.73 3.17a2.42 2.42 0 0 0 2.83-.62 5.2 5.2 0 0 0 1.53-5.17c-1.16-3.73-5.78-3.22-8.19-1.05Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "202.634px 235.442px"
    },
    className: "animable",
    id: "el2pj5segsqo8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.06 273.21c4.64 4.37 10.67 6.9 16.86 4.29.53-.23 1.14-.82.78-1.27 0 0-3.82.47-4.26.44-8.67-.59-15.89-8.85-18.7-16.58-.45-1.24-.82-3.69-1.85-4.58-1.24-1.08-.93.71-.8 1.55a28.43 28.43 0 0 0 1.25 5.61 27 27 0 0 0 6.7 10.52Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "215.883px 266.865px"
    },
    className: "animable",
    id: "elajstrzmu3x5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.58 256.52a3 3 0 0 0-.67 1.55 3 3 0 0 0 1.27 2.43 10.59 10.59 0 0 0 2.54 1.27 29.77 29.77 0 0 1 8.9 5.73 1.43 1.43 0 0 0 .86.49.94.94 0 0 0 .85-.85 2.61 2.61 0 0 0-.26-1.28 31.32 31.32 0 0 0-5.91-9.39c-2.16-2.31-5.49-2.68-7.58.05Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "252.122px 261.297px"
    },
    className: "animable",
    id: "elxf2havi5wp"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.93 234.1a2.39 2.39 0 0 0-.64 2.41 4.75 4.75 0 0 0 1.57 2.2 22.18 22.18 0 0 0 4.65 2.93 7.72 7.72 0 0 1 3.12 4.63c.09.39.23.87.62.91a.72.72 0 0 0 .4-.12 2.46 2.46 0 0 0 .85-1.81c.47-3.46.09-7-2.4-9.6a7.65 7.65 0 0 0-5.38-2.63 4.15 4.15 0 0 0-2.79 1.08Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "300.932px 240.1px"
    },
    className: "animable",
    id: "eluc3f8g8zxt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.52 281.09a26.08 26.08 0 0 1-3.37 1.72 13.27 13.27 0 0 1-9.23.18 10.74 10.74 0 0 0 7.37 3.26 19.2 19.2 0 0 0 8.07-1.53c1.93-.76 5.09-2.6 4.21-5.17-1.07-3.11-5.51.66-7.05 1.54Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "311.821px 282.299px"
    },
    className: "animable",
    id: "elo62s4p54fj"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.15 268a1.11 1.11 0 0 0 .57.9 3.64 3.64 0 0 0 1 .36 9 9 0 0 1 1.93.8 12.45 12.45 0 0 0 1.6.88.43.43 0 0 0 .35 0 .41.41 0 0 0 .23-.28 1.85 1.85 0 0 0-.31-1.53 4.59 4.59 0 0 0-3.68-2.06 2 2 0 0 0-1.55.55.59.59 0 0 0-.14.38Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "179.016px 269.02px"
    },
    className: "animable",
    id: "elopxplzhyp4g"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.75 237.77a19.79 19.79 0 0 0 2.5.83l2.14.61a1.24 1.24 0 0 0 .47.06.77.77 0 0 0 .6-.68c.39-2.88-4.42-6.06-6.84-4.39a1.83 1.83 0 0 0-.66 2.23 2.42 2.42 0 0 0 1 .94 7.16 7.16 0 0 0 .79.4Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "300.649px 236.505px"
    },
    className: "animable",
    id: "el9ctel8h7fc8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.83 235a3.12 3.12 0 0 1 .27 1.08c0 .55-.06 1.2.36 1.56a1 1 0 0 0 1.27 0 2.55 2.55 0 0 0 .76-1.13 4.26 4.26 0 0 0 .28-2.93 2.07 2.07 0 0 0-2.55-1.39c-1.63.52-.89 1.72-.39 2.81Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "204.066px 234.989px"
    },
    className: "animable",
    id: "elm9gkt2hb8w"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.39 257.89a1.78 1.78 0 0 0 .7.63l5.54 3.31a.53.53 0 0 0 .35.12c.22 0 .33-.26.39-.47a4 4 0 0 0-1.72-4.05c-1-.85-2.33-1.71-3.7-1.39-.85.2-2.09.77-1.56 1.85Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "250.849px 258.961px"
    },
    className: "animable",
    id: "elqk5px3tp6i"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.95,
    cy: 231.07,
    r: 9.69,
    style: {
      fill: "#b0bec5",
      transformOrigin: "331.95px 231.07px",
      transform: "rotate(-80.78deg)"
    },
    className: "animable",
    id: "elnnjgmnsi9q7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.95,
    cy: 231.07,
    r: 9.69,
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "331.95px 231.07px",
      transform: "rotate(-80.78deg)"
    },
    className: "animable",
    id: "el7jr21wp2mhw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332 221.38a9.69 9.69 0 1 0 9.69 9.69 9.32 9.32 0 0 0-.17-1.77c.56 2.86-4 7-9.52 4.15s-4.56-10.27 0-12.07Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "332px 231.07px"
    },
    id: "elurtyelbvh9p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332 221.38a9.69 9.69 0 1 0 9.69 9.69 9.32 9.32 0 0 0-.17-1.77c.56 2.86-4 7-9.52 4.15s-4.56-10.27 0-12.07Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "332px 231.07px"
    },
    className: "animable",
    id: "el1hk69qessds"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.16 236.21c-.19.24-3.56 4.32-10 2.19-6.66-2.2-7.09-11.35-3.48-15.44a9.69 9.69 0 1 0 13.51 13.25Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "331.235px 231.864px"
    },
    id: "elmv4zp0jpyk8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.39 228.06a13.82 13.82 0 0 1 1.33 1.43 9.59 9.59 0 0 1 1.45 5.26c.07 1.18.89 2.06 2 1.27a4 4 0 0 0 1.38-2.37 9.58 9.58 0 0 0-.46-6.55 7.55 7.55 0 0 0-3.81-3.64 2.66 2.66 0 0 0-2.94.47c-1 1.16-.41 2.56.48 3.57.18.19.39.38.57.56Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "335.87px 229.767px"
    },
    className: "animable",
    id: "el471ija3caoj"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.11 238.32a.91.91 0 0 0 .45.71 1.05 1.05 0 0 0 .31.12 1.65 1.65 0 0 0 2-1.11 1 1 0 0 0-.95-1.32 1.87 1.87 0 0 0-1.41.62 1.33 1.33 0 0 0-.36.88Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "335.516px 237.963px"
    },
    className: "animable",
    id: "elwqwm0efhpme"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.61 332.76a6.37 6.37 0 1 1-6.37-6.37 6.38 6.38 0 0 1 6.37 6.37Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "257.24px 332.76px"
    },
    id: "eljljqf2cn2l8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.61 332.76a6.37 6.37 0 1 1-6.37-6.37 6.38 6.38 0 0 1 6.37 6.37Z",
    style: {
      fill: "#fff",
      opacity: 0.6,
      transformOrigin: "257.24px 332.76px"
    },
    className: "animable",
    id: "elkbizhgiknrj"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.24 326.39a6.38 6.38 0 1 0 6.37 6.37 6.45 6.45 0 0 0-.11-1.17c.37 1.89-2.66 4.61-6.26 2.74s-2.96-6.76 0-7.94Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "257.23px 332.77px"
    },
    id: "elyvs2dwjch4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.24 326.39a6.38 6.38 0 1 0 6.37 6.37 6.45 6.45 0 0 0-.11-1.17c.37 1.89-2.66 4.61-6.26 2.74s-2.96-6.76 0-7.94Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "257.23px 332.77px"
    },
    className: "animable",
    id: "elqiwql1k8li"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.64 336.14c-.13.16-2.34 2.85-6.6 1.44s-4.66-7.46-2.29-10.15a6.37 6.37 0 1 0 8.89 8.71Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.5,
      transformOrigin: "256.756px 333.279px"
    },
    className: "animable",
    id: "el069wts4o0d3l"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.19 330.78a8.57 8.57 0 0 1 .87.94 6.3 6.3 0 0 1 1 3.47c0 .77.58 1.35 1.34.83a2.7 2.7 0 0 0 .91-1.56 6.27 6.27 0 0 0-.31-4.31 4.93 4.93 0 0 0-2.5-2.39 1.75 1.75 0 0 0-1.94.31c-.67.76-.26 1.68.32 2.34.12.13.19.25.31.37Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "259.884px 331.907px"
    },
    className: "animable",
    id: "elzz34bennfyh"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.67 337.53a.6.6 0 0 0 .29.47.7.7 0 0 0 .2.08 1.09 1.09 0 0 0 1.29-.73.67.67 0 0 0-.62-.87 1.19 1.19 0 0 0-.93.41.89.89 0 0 0-.24.58.13.13 0 0 0 .01.06Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "259.57px 337.294px"
    },
    className: "animable",
    id: "elet1dh49jwhr"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.63 249.12a7.15 7.15 0 1 1-10.11.53 7.15 7.15 0 0 1 10.11-.53Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "162.839px 254.428px"
    },
    id: "el3nxrrmnrxvx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.63 249.12a7.15 7.15 0 1 1-10.11.53 7.15 7.15 0 0 1 10.11-.53Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "162.839px 254.428px"
    },
    className: "animable",
    id: "eleci0lllscm4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.52 249.65a7.15 7.15 0 1 0 10.11-.53 6.57 6.57 0 0 0-1.06-.78c1.86 1.11 1.84 5.67-2.43 7.28s-7.86-2.62-6.62-5.97Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "162.839px 254.959px"
    },
    id: "elln0zpfdhvd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.52 249.65a7.15 7.15 0 1 0 10.11-.53 6.57 6.57 0 0 0-1.06-.78c1.86 1.11 1.84 5.67-2.43 7.28s-7.86-2.62-6.62-5.97Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "162.839px 254.959px"
    },
    className: "animable",
    id: "elati2hhrj5bt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.72 252.47c0 .23.61 4.09-3.76 6.59s-9.73-1.72-10.19-5.72a7.15 7.15 0 1 0 13.95-.87Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "162.839px 257.016px"
    },
    id: "ele9nxkqsqio",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.9 252.15a9.89 9.89 0 0 1 1.44 0 7.12 7.12 0 0 1 3.61 1.8c.68.55 1.56.53 1.7-.49a3 3 0 0 0-.62-1.93 7.07 7.07 0 0 0-3.82-3 5.64 5.64 0 0 0-3.88.29 2 2 0 0 0-1.19 1.85c.13 1.13 1.2 1.49 2.19 1.5Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "163.896px 251.312px"
    },
    className: "animable",
    id: "elxkb064r5lor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.89 256.83a.67.67 0 0 0 .61.11.53.53 0 0 0 .21-.11 1.23 1.23 0 0 0 .37-1.63.77.77 0 0 0-1.2-.13 1.38 1.38 0 0 0-.35 1.08 1 1 0 0 0 .3.64Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "168.383px 255.905px"
    },
    className: "animable",
    id: "elpvgb6f73pqf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.57 227.74a3.65 3.65 0 1 1-5.17.26 3.66 3.66 0 0 1 5.17-.26Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "161.114px 230.442px"
    },
    id: "elm7ttooklo8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.57 227.74a3.65 3.65 0 1 1-5.17.26 3.66 3.66 0 0 1 5.17-.26Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "161.114px 230.442px"
    },
    className: "animable",
    id: "el17r26hgn7y5h"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.4 228a3.66 3.66 0 1 0 5.17-.26 3.27 3.27 0 0 0-.54-.4c.94.56.93 2.89-1.24 3.71a2.54 2.54 0 0 1-3.39-3.05Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "161.115px 230.727px"
    },
    id: "elo6lzug2rubr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.4 228a3.66 3.66 0 1 0 5.17-.26 3.27 3.27 0 0 0-.54-.4c.94.56.93 2.89-1.24 3.71a2.54 2.54 0 0 1-3.39-3.05Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "161.115px 230.727px"
    },
    className: "animable",
    id: "eloj7zua2qh1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.63 229.45a3.36 3.36 0 0 1-1.92 3.36c-2.3 1.31-5-.88-5.2-2.92a3.65 3.65 0 1 0 7.12-.44Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "161.118px 231.772px"
    },
    id: "elepnv3wm67lg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.64 229.29a3.66 3.66 0 0 1 .74 0 3.58 3.58 0 0 1 1.84.92c.34.28.8.27.86-.25a1.52 1.52 0 0 0-.31-1 3.59 3.59 0 0 0-2-1.52 2.82 2.82 0 0 0-2 .14 1 1 0 0 0-.61.95c.07.57.61.76 1.12.76Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "161.621px 228.856px"
    },
    className: "animable",
    id: "el8ymosj66xq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.7 231.67a.32.32 0 0 0 .31.06.3.3 0 0 0 .11-.06.62.62 0 0 0 .18-.83.39.39 0 0 0-.61-.07.76.76 0 0 0-.18.56.49.49 0 0 0 .16.32Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "163.948px 231.2px"
    },
    className: "animable",
    id: "el258prxr45qth"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.35 270.31a3.65 3.65 0 1 1-4.49-2.57 3.65 3.65 0 0 1 4.49 2.57Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "370.826px 271.26px"
    },
    id: "eljkt3dupd3x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.35 270.31a3.65 3.65 0 1 1-4.49-2.57 3.65 3.65 0 0 1 4.49 2.57Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "370.826px 271.26px"
    },
    className: "animable",
    id: "elumg1ckfsmh9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.86 267.74a3.65 3.65 0 1 0 4.49 2.57 3.41 3.41 0 0 0-.24-.63c.49 1-.78 2.94-3.05 2.45a2.54 2.54 0 0 1-1.2-4.39Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "370.826px 271.325px"
    },
    id: "elpa86oiqxvu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.86 267.74a3.65 3.65 0 1 0 4.49 2.57 3.41 3.41 0 0 0-.24-.63c.49 1-.78 2.94-3.05 2.45a2.54 2.54 0 0 1-1.2-4.39Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "370.826px 271.325px"
    },
    className: "animable",
    id: "elyaja9xsjxfe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.32 272.33a3.37 3.37 0 0 1-3.43 1.78c-2.65-.14-3.71-3.42-2.8-5.27a3.65 3.65 0 1 0 6.23 3.49Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "370.752px 271.868px"
    },
    id: "elzjjdvv4svte",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.05 270a6 6 0 0 1 .63.39 3.75 3.75 0 0 1 1.05 1.77c.14.42.52.66.86.26a1.52 1.52 0 0 0 .27-1 3.61 3.61 0 0 0-.82-2.34 2.87 2.87 0 0 0-1.74-.95 1 1 0 0 0-1 .47c-.25.52.11 1 .53 1.25Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "372.041px 270.372px"
    },
    className: "animable",
    id: "elacyn0w3vk4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.33 273.69a.36.36 0 0 0 .23.22h.13a.62.62 0 0 0 .6-.6.39.39 0 0 0-.48-.39.72.72 0 0 0-.45.37.5.5 0 0 0 0 .36l-.03.04Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "372.808px 273.41px"
    },
    className: "animable",
    id: "ela493ttxr44q"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.19 326c-.08-5-2.67-7.6-9.85-13.24-7.92-6.23-7.91-11.23-13.34-11.23s-5.42 5-13.34 11.23c-7.18 5.64-9.77 8.22-9.85 13.24-.1 3.5 2.16 7 6.79 9.7 9.06 5.23 23.74 5.23 32.8 0 4.6-2.7 6.89-6.24 6.79-9.7Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "250px 320.576px"
    },
    id: "elen2fpjr6isj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.19 326c-.08-5-2.67-7.6-9.85-13.24-7.92-6.23-7.91-11.23-13.34-11.23s-5.42 5-13.34 11.23c-7.18 5.64-9.77 8.22-9.85 13.24-.1 3.5 2.16 7 6.79 9.7 9.06 5.23 23.74 5.23 32.8 0 4.6-2.7 6.89-6.24 6.79-9.7Z",
    style: {
      fill: "#fff",
      opacity: 0.35,
      transformOrigin: "250px 320.576px"
    },
    className: "animable",
    id: "elkqc639n1skc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263 335.12a27.09 27.09 0 0 1-22.34-3.29 11.15 11.15 0 0 1-4.47-5.1c-2.25-6.11 3.76-10.83 6.45-15.55 1.19-2.08 2-4.39 3.19-6.44a10.41 10.41 0 0 1 2.84-3.14c-4.19.77-4.81 5.43-12 11.12s-9.77 8.22-9.85 13.24c-.1 3.5 2.16 7 6.79 9.7 9.06 5.23 23.74 5.23 32.8 0a14.46 14.46 0 0 0 5.76-5.53 21.84 21.84 0 0 1-9.17 4.99Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.35,
      transformOrigin: "249.493px 320.591px"
    },
    className: "animable",
    id: "elnlxhftcvic"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.52 303.76a2.85 2.85 0 0 0-.83 1.05 6.1 6.1 0 0 0-.73 3.59 4.34 4.34 0 0 0 1.84 3.11 5.66 5.66 0 0 0 2.52.8c1.17.14 2.57 0 3.2-1a2.47 2.47 0 0 0 .1-2.19 7.41 7.41 0 0 0-1.24-1.9l-2.16-2.66c-.62-.79-1.75-1.48-2.7-.8Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "252.878px 307.919px"
    },
    className: "animable",
    id: "eld4d4y9lpp5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.81 315.27a.77.77 0 0 0 0 .15c-.56 4.24 3.79 5.54 6 8.22a7 7 0 0 1 1.81 4.44 8.14 8.14 0 0 1-1.83 4.65c-1.1 1.51.14 1.87 1.38 1.4a9.8 9.8 0 0 0 3.75-2.51 9.32 9.32 0 0 0 2.1-9c-.68-2.13-2.76-4.11-4.3-5.63s-8.1-6.99-8.91-1.72Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "263.584px 323.675px"
    },
    className: "animable",
    id: "elyr53ftv443"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.54 355.77c-8.58-7.5-11.89-14.83-14-25.69-1.13-5.68-6.94-8.77-6.33-14.73.37-3.56 2.16-6.81 3.23-10.23a26.33 26.33 0 0 0 1-10.8 11.18 11.18 0 0 0-1.29-4.43c-2.82-4.77-8.43-2.77-13.07-2.65-3.9.1-8.94-.24-11.14-4a8.35 8.35 0 0 1 .71-9.08c1.93-2.41 5.36-3 8.44-2.85 17.2.92 25.3 17.23 26 32.92.23 5.11-.16 10.44 1.94 15.1 4.52 10 16.86 2.35 20.68 12.53 1 2.7 1.26 5.62 2 8.41a21 21 0 0 0 9.73 13 6.42 6.42 0 0 0 6.17.43 6.76 6.76 0 0 0 2.7-3.06c2.2-4.58.89-10 .11-15s-.62-11 3.39-14.11c4.43-3.45 9.47-2 12.89 2.07 3.81 4.54 1.8 7.76-.14 13.07a39.16 39.16 0 0 0-2.09 8.75c-.44 3.63 0 8 3.17 9.85 3.39 2 7.69-.26 10.47-3 1.63-1.61 3.31-6.65 5.87-7.14 4.31-.83 6.21 10.4 9.12 13.18 2.72 2.59 6.95 4 10.31 2.3 2.35-1.16 3.84-3.53 5.13-5.82a143.14 143.14 0 0 0 10.77-23.85c.77-2.22 1.55-4.58 3.32-6.13s4.86-1.85 6.27 0c.42.57.65 1.26 1.1 1.8 1.28 1.53 3.87 1.19 5.36-.14s2.19-3.31 2.95-5.16a50.92 50.92 0 0 1 14.61-19.93c1.54-1.29 4.7-1.87 4.83.13a3.06 3.06 0 0 1-.8 1.85 24.58 24.58 0 0 0-4.43 11.43c-.11 1-.08 2.12.71 2.67 1 .68 2.26 0 3.19-.73a35.8 35.8 0 0 0 12.36-18.62c1.81-6.63 1.94-14.29 6.81-19.13 5.35-5.31 15.55-4.19 19.61 2.15 1.51 2.35 2.18 5.46.92 8-1.63 3.23-5.63 4.24-9 5.53-7.93 3-14.33 9.34-18.7 16.63s-6.86 15.54-8.66 23.85a31.63 31.63 0 0 1-5.09 12.38C310.24 364.09 289.7 378 250 378s-63.29-17.71-68.46-22.23Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "251.852px 324.644px"
    },
    id: "elp5fwxgw3a4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.54 355.77c-8.58-7.5-11.89-14.83-14-25.69-1.13-5.68-6.94-8.77-6.33-14.73.37-3.56 2.16-6.81 3.23-10.23a26.33 26.33 0 0 0 1-10.8 11.18 11.18 0 0 0-1.29-4.43c-2.82-4.77-8.43-2.77-13.07-2.65-3.9.1-8.94-.24-11.14-4a8.35 8.35 0 0 1 .71-9.08c1.93-2.41 5.36-3 8.44-2.85 17.2.92 25.3 17.23 26 32.92.23 5.11-.16 10.44 1.94 15.1 4.52 10 16.86 2.35 20.68 12.53 1 2.7 1.26 5.62 2 8.41a21 21 0 0 0 9.73 13 6.42 6.42 0 0 0 6.17.43 6.76 6.76 0 0 0 2.7-3.06c2.2-4.58.89-10 .11-15s-.62-11 3.39-14.11c4.43-3.45 9.47-2 12.89 2.07 3.81 4.54 1.8 7.76-.14 13.07a39.16 39.16 0 0 0-2.09 8.75c-.44 3.63 0 8 3.17 9.85 3.39 2 7.69-.26 10.47-3 1.63-1.61 3.31-6.65 5.87-7.14 4.31-.83 6.21 10.4 9.12 13.18 2.72 2.59 6.95 4 10.31 2.3 2.35-1.16 3.84-3.53 5.13-5.82a143.14 143.14 0 0 0 10.77-23.85c.77-2.22 1.55-4.58 3.32-6.13s4.86-1.85 6.27 0c.42.57.65 1.26 1.1 1.8 1.28 1.53 3.87 1.19 5.36-.14s2.19-3.31 2.95-5.16a50.92 50.92 0 0 1 14.61-19.93c1.54-1.29 4.7-1.87 4.83.13a3.06 3.06 0 0 1-.8 1.85 24.58 24.58 0 0 0-4.43 11.43c-.11 1-.08 2.12.71 2.67 1 .68 2.26 0 3.19-.73a35.8 35.8 0 0 0 12.36-18.62c1.81-6.63 1.94-14.29 6.81-19.13 5.35-5.31 15.55-4.19 19.61 2.15 1.51 2.35 2.18 5.46.92 8-1.63 3.23-5.63 4.24-9 5.53-7.93 3-14.33 9.34-18.7 16.63s-6.86 15.54-8.66 23.85a31.63 31.63 0 0 1-5.09 12.38C310.24 364.09 289.7 378 250 378s-63.29-17.71-68.46-22.23Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "251.852px 324.644px"
    },
    className: "animable",
    id: "elzmfap8qpm9s"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.84 375.59c-20.4-1.18-43.32-8.29-59.91-20.23a40.2 40.2 0 0 1-14.66-20.11c-1.58-4.71-.68-8.05-4.07-11.7-2.11-2.26-5.71-3.75-7.34-6.46-1.37-2.27-1.23-5.41-.91-8a24.67 24.67 0 0 0-1.79 6.31c-.61 6 5.2 9 6.33 14.73 2.16 10.86 5.47 18.19 14 25.69C186.71 360.29 210.3 378 250 378c15.23 0 27.64-2.05 37.85-5.51-12.58 2.33-25.27 3.84-38.01 3.1Zm-15-16.6c2.76 1.14 6.07.06 8.23-2a14.73 14.73 0 0 0 3.37-5.28 5.15 5.15 0 0 1-.42.48c-2.78 2.76-7.08 5-10.47 3-3.17-1.83-3.61-6.22-3.17-9.85.07-.58.16-1.16.26-1.73a18.8 18.8 0 0 0-2.19 6.83c-.23 3.43 1.28 7.24 4.44 8.56Zm-35.46-5.56a19.42 19.42 0 0 0 12.07 4 13.38 13.38 0 0 0 5.39-.92c4.27-1.83 6.49-6.46 8.35-10.73a19.8 19.8 0 0 0 1.78-5.52 6.66 6.66 0 0 0-1.55-5.43 27.11 27.11 0 0 0-3.53-2.41 8.11 8.11 0 0 1-3.13-6.66 21.09 21.09 0 0 0-.43 9.82c.78 5 2.09 10.41-.11 15a6.76 6.76 0 0 1-2.7 3.06 6.42 6.42 0 0 1-6.17-.43 21 21 0 0 1-9.73-13c-.71-2.79-1-5.71-2-8.41a9.49 9.49 0 0 0-1.44-2.61 10.47 10.47 0 0 1 .06 3.53c-.49 3.17-2 6.16-2.17 9.36a13.92 13.92 0 0 0 5.36 11.35Zm-35.29-63.54a11.18 11.18 0 0 1 1.29 4.43 27.46 27.46 0 0 1 .16 3 9.23 9.23 0 0 0 1.44-4.89c-.09-3.55-2.89-6.52-6.06-8.12s-6.74-2.18-10.13-3.22a10.68 10.68 0 0 1-4.38-2.27 4.43 4.43 0 0 1-1.32-4.53c.6-1.65 2.38-2.56 4.09-3h-.15c-3.08-.16-6.51.44-8.44 2.85a8.35 8.35 0 0 0-.71 9.08c2.2 3.78 7.24 4.12 11.14 4 4.69-.1 10.3-2.1 13.12 2.67Zm199-8.8c-2.9-4.53-8.92-6.38-14.08-5.14a22.19 22.19 0 0 1 3.15.74 12.48 12.48 0 0 1 5.66 3.12c4.92 5.27-1.72 9.82-5.87 12.31-6.77 4.06-12.94 10.07-14.78 17.71 4.33-6.7 10.41-12.41 17.84-15.26 3.37-1.29 7.37-2.3 9-5.53 1.33-2.49.66-5.6-.85-7.95Zm-59.84 45.34c-1.45 1.29-3.93 1.64-5.24.25 1 2.35 2.84 4.92 4.68 5.43 2.66.74 4-2.09 4.78-4.14q2.47-6.36 4.82-12.76c1.47-4 3.13-8.31 5.85-11.48a51 51 0 0 0-11.94 17.54c-.69 1.85-1.38 3.83-2.88 5.16Zm-16.05 4.44a143.14 143.14 0 0 1-10.77 23.85c-1.29 2.29-2.78 4.66-5.13 5.82-3.36 1.67-7.59.29-10.31-2.3-1.71-1.64-3.08-6.2-4.79-9.51 1.28 5.18 1 11.07 4.76 14.72a10.18 10.18 0 0 0 9.74 2.17c6.67-1.92 10.53-10.19 13-16.13 3-7.3 4.61-15.1 7.32-22.51a8.6 8.6 0 0 1 1.68-3.09c.12-.12.25-.23.38-.34a5.38 5.38 0 0 0-2.54 1.19c-1.72 1.55-2.54 3.91-3.27 6.13Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.3,
      transformOrigin: "251.793px 324.633px"
    },
    className: "animable",
    id: "elwywwobpuj9q"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.68 274.66c-1 .87-1.75 2.42-1 3.57.82 1.35 2.8 1.17 4.37.95a40.64 40.64 0 0 1 12.26.13c.79.14 3.81 1.05 4.41.32 1-1.17-2.8-3.26-3.5-3.67-4.72-2.7-11.77-5.29-16.54-1.3Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "152.131px 276.258px"
    },
    className: "animable",
    id: "elu1i87xrfvb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.33 311.07c-.29.87-.56 1.74-.8 2.62a7.87 7.87 0 0 0 .66 5.75c.47.88 1.64 2.39 2.81 1.94s1.44-2.27 1.43-3.34c0-1.45-.14-2.9-.15-4.33 0-1.64.12-3.28.14-4.91a7.42 7.42 0 0 0-.86-4.25c-.11-.16-.26-.33-.45-.3s-.31.24-.38.43c-.82 2.13-1.67 4.24-2.4 6.39Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "164.858px 312.854px"
    },
    className: "animable",
    id: "el1go7fndrsjn"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.43 327.45a3.21 3.21 0 0 0-2.33 1.14c-.94 1.27-.36 3.16.77 4.27a17.43 17.43 0 0 0 4 2.43 15.93 15.93 0 0 1 4.76 4c.59.74 1.69 3.56 2.87 3.21a.51.51 0 0 0 .29-.19.69.69 0 0 0 .08-.4v-2.22c0-3.35-.6-6.48-2.87-9.07a9.12 9.12 0 0 0-7.57-3.17Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "191.252px 334.979px"
    },
    className: "animable",
    id: "el2cddw2etgge"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.35 325.81a5.11 5.11 0 0 0 1.75 3.24 12 12 0 0 1 2.44 2.84c.64 1.27.85 3 2.18 3.52 1.18.44 2.44-.48 3.19-1.5 1.6-2.18 2.58-5.64 1.29-8.18-.89-1.74-3.68-4-5.71-4.06-2.18-.07-5.21 1.74-5.14 4.14Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "229.072px 328.595px"
    },
    className: "animable",
    id: "elvg2rqr6vwrr"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.14 347.9a2.47 2.47 0 0 0-.27 2.12 8 8 0 0 0 1 2 49 49 0 0 1 4.07 8.37 6.88 6.88 0 0 0 1.06 2.11 4.31 4.31 0 0 0 .86-2.39 15.69 15.69 0 0 0-1.54-8.68c-.67-1.35-3.32-6.03-5.18-3.53Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "254.349px 354.839px"
    },
    className: "animable",
    id: "elhhbk8iy7uja"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.31 327.07a2.5 2.5 0 0 0 1 1.84 17.79 17.79 0 0 0 1.78 1.19 8.33 8.33 0 0 1 2.82 3.19 4 4 0 0 0 .79 1.25 1 1 0 0 0 1.34.09 1.45 1.45 0 0 0 .3-1 10.91 10.91 0 0 0-.31-3.7 7.78 7.78 0 0 0-3.47-4.58c-1.56-.79-4.22-.45-4.25 1.72Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "295.346px 329.904px"
    },
    className: "animable",
    id: "elk60xhjtuqfm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.68 280.22a13.26 13.26 0 0 0-4.4 9.28 1.44 1.44 0 0 0 .19.92 1.15 1.15 0 0 0 .65.39c1.82.52 3.58-.78 5.18-1.77a19.18 19.18 0 0 1 7.82-2.71c1.89-.21 4.06-.27 5.27-1.74 2.76-3.38-1.87-6.58-4.67-7.39-3.36-.99-7.52.8-10.04 3.02Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "351.253px 283.925px"
    },
    className: "animable",
    id: "el8mxq9let1sc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.14 280.9a2.45 2.45 0 0 0 1.44 2.28 10 10 0 0 0 4.64 1c1.88.07 3.71-1.53 2.74-3.42a4.78 4.78 0 0 0-4.22-2.27c-1.74-.09-4.26.32-4.6 2.41Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "354.684px 281.331px"
    },
    className: "animable",
    id: "elcp29heas4om"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293 327.37a.9.9 0 0 0 .41.36l2.24 1.3a1.16 1.16 0 0 0 1 .22 1 1 0 0 0 .37-1.11 3 3 0 0 0-2.15-2.23c-.78-.24-2.48.23-1.87 1.46Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "294.968px 327.566px"
    },
    className: "animable",
    id: "elpptfuw0c42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.3 324.47a2.12 2.12 0 0 0 0 1.84 7.73 7.73 0 0 0 1 1.62 19.93 19.93 0 0 1 1.44 2.39 2.61 2.61 0 0 0 1 1.29 1.92 1.92 0 0 0 2.18-.71 4.5 4.5 0 0 0 .33-5.13 7.11 7.11 0 0 0-1.65-1.68c-1.19-.87-3.43-1.09-4.3.38Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "230.494px 327.556px"
    },
    className: "animable",
    id: "elln1f8hnc6i"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.11 274.78A3.5 3.5 0 0 0 143 277a.9.9 0 0 0 .11.63.85.85 0 0 0 .65.26c1.37.05 2.48-1 3.77-1.5.65-.23 1.36-.3 2-.49.51-.14 1.08-.45 1.1-1a.93.93 0 0 0-.39-.72 2.12 2.12 0 0 0-.77-.33c-1.61-.45-4.04-.28-5.36.93Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "146.807px 275.757px"
    },
    className: "animable",
    id: "elkk5sgmoz2pf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.36 265.64a27.36 27.36 0 0 1-54.72 0c0-15.11 12.25-32.12 27.36-32.12s27.36 17.01 27.36 32.12Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "250px 263.26px"
    },
    id: "elejookk299q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.36 265.64a27.36 27.36 0 0 1-54.72 0c0-15.11 12.25-32.12 27.36-32.12s27.36 17.01 27.36 32.12Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "250px 263.26px"
    },
    className: "animable",
    id: "el3ktgojzz0ui"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 233.52c-15.11 0-27.36 17-27.36 32.12a27.36 27.36 0 0 0 54.72 0 26.68 26.68 0 0 0-.47-5c1.59 8.1-11.41 19.75-26.89 11.73s-12.72-33.77 0-38.85Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.3,
      transformOrigin: "250px 263.26px"
    },
    className: "animable",
    id: "elpcuowf46bc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.14 292.91c.4 0 .79-.07 1.18-.12l.5-.06c.44-.06.87-.13 1.31-.22l.29-.05c.52-.1 1.05-.23 1.57-.36l.32-.09 1.23-.37.41-.14q.6-.21 1.2-.45l.29-.12a26 26 0 0 0 2.91-1.41l.25-.14c.4-.23.79-.47 1.18-.72l.21-.13a26.49 26.49 0 0 0 2.63-2h.05q.6-.51 1.17-1l.11-.11a26.72 26.72 0 0 0 3.27-3.77v-.06c.32-.45.63-.91.92-1.38-.55.69-10.06 12.2-28.32 6.18-18.8-6.21-20.12-35.24-9.94-46.82-7.41 6.3-12.29 16.59-12.29 26.13a27.37 27.37 0 0 0 24.54 27.22c.94.09 1.88.14 2.82.14.55 0 1.1 0 1.65-.05Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.6,
      transformOrigin: "247.865px 266.315px"
    },
    className: "animable",
    id: "elwyurbbm1vg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.08 254.19a37 37 0 0 1 3.76 4.06c3.09 4.19 3.8 9.65 4.09 14.86.2 3.32 2.5 5.79 5.75 3.56 2.17-1.49 3.23-4.13 3.9-6.68 1.59-6.11 1.48-12.83-1.3-18.5-2.07-4.23-6.23-8.63-10.75-10.28-2.76-1-6.24-1-8.32 1.34-2.86 3.26-1.14 7.21 1.38 10.07.48.54.98 1.06 1.49 1.57Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "261.168px 259.05px"
    },
    className: "animable",
    id: "elg62a94u5ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.12 283.17a2.67 2.67 0 0 0 1.25 2 2.82 2.82 0 0 0 .88.32c2.29.47 5-.74 5.54-3.12a2.9 2.9 0 0 0-2.67-3.74 5.29 5.29 0 0 0-4 1.76 3.76 3.76 0 0 0-1 2.48 2.46 2.46 0 0 0 0 .3Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "260.015px 282.11px"
    },
    className: "animable",
    id: "elkc2dvzbfr1r"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Drop--inject-58",
    className: "animable animator-active",
    style: {
      transformOrigin: "250px 160.01px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideDown,1.5s Infinite linear floating",
      animationDelay: "0s,1s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--water-drop--inject-58",
    className: "animable",
    style: {
      transformOrigin: "250px 160.01px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--drop--inject-58",
    className: "animable",
    style: {
      transformOrigin: "250px 160.01px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250 96.14c-25.61 29.82-45.89 59.18-45.89 83.57s20.54 44.16 45.89 44.16 45.89-19.77 45.89-44.16S275.61 126 250 96.14Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "250px 160.005px"
    },
    id: "elar5k90ztw5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 96.14c-25.61 29.82-45.89 59.18-45.89 83.57s20.54 44.16 45.89 44.16 45.89-19.77 45.89-44.16S275.61 126 250 96.14Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "250px 160.005px"
    },
    className: "animable",
    id: "elqv2g2h2nbis"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247 118c-4.56 5.43-6.12 12.91-6.46 20a46.33 46.33 0 0 0 2.29 18.13c3.14 8.58 10.6 16.14 20.24 16.28a14 14 0 0 0 11.68-5.9 19.25 19.25 0 0 0 2.76-9.64c.71-11.75-3.79-23.35-10.43-33.08-4.24-6.22-12.35-14-19.25-6.76-.26.39-.53.69-.83.97Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "259px 143.264px"
    },
    className: "animable",
    id: "elzuqpboi1nk"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.89 179.71a58.13 58.13 0 0 0-3.34-18.48c2.44 8.66-8.17 39.38-39 30.69s-36.37-48.08-15.84-80.92c-19.51 24.61-33.6 48.39-33.6 68.72 0 24.39 20.54 44.16 45.89 44.16s45.89-19.78 45.89-44.17Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "250px 167.44px"
    },
    id: "elgtlkv4a2ptd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.57 203.65c-7.16 7.46-18.16 13.11-34.86 10.76-40.34-5.69-48.41-48.71-38.73-70.07-6.8 12.52-10.87 24.44-10.87 35.37 0 24.39 20.54 44.16 45.89 44.16a46.31 46.31 0 0 0 38.57-20.22Z",
    style: {
      opacity: 0.1,
      transformOrigin: "246.34px 184.106px"
    },
    className: "animable",
    id: "elaxghvs6bh1m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.79 134c.91 3.67 2.91 7 6.9 6.44a5.83 5.83 0 0 0 4.93-5.24 10.12 10.12 0 0 0-1.93-6.72 14.14 14.14 0 0 0-5.15-4.87 3.89 3.89 0 0 0-4.11.32 4.93 4.93 0 0 0-1.52 3.75 27.54 27.54 0 0 0 .88 6.32Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "263.277px 131.835px"
    },
    className: "animable",
    id: "eluewvn4yzx6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.41 173.39c.67 11-.31 22.94-7.64 31.1-1.43 1.59-3.27 3.07-5.41 3.08-2.79 0-5-2.58-5.66-5.3s-.15-5.55.14-8.32a52.56 52.56 0 0 0-1.77-20c-1.6-5.54-4.14-10.87-4.69-16.61s1.47-12.29 6.65-14.82c5.46-2.65 10.71 2.78 12.92 7.2 3.54 7.1 4.99 15.83 5.46 23.67Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "275.939px 174.696px"
    },
    className: "animable",
    id: "el1926e01qysv"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "red",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.2dfb8100970e520672c28d8d4c5a63e4.svg";
export { ForwardRef as ReactComponent };